import { useThemeVariable, classNames, combineRefs, useControllableState, tags, use_UNSAFEUserAgentInfo, Dialog, useUniqueId } from '@dsx-react/util';
import { forwardRef, useRef, useLayoutEffect, useState, useCallback, useEffect, useMemo, createElement } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { MdCheck, MdClose, MdClear, MdSearch, MdNavigateBefore, MdNavigateNext, MdToday, UNSAFE_Icon, DsxLoadingSpinner, DsxFileDocument, MdDelete, MdError, StandaloneIcon, MdUpload, MdKeyboardArrowDown, MdCheckBox, MdCheckBoxOutlineBlank, MdIndeterminateCheckBox, MdKeyboardArrowRight, MdDone, MdSend, MdInfo, MdWarning, MdCheckCircle } from '@dsx-react/icon';
import { Button } from '@dsx-react/button';
import { useMessageFormatter, useI18n, getCurrencyFormat } from '@dsx-react/i18n';
import { Menu, MenuItem } from '@dsx-react/menu';
import { Text } from '@dsx-react/text';
import calendarize from 'calendarize';
import { useDropzone } from 'react-dropzone';
import { Card } from '@dsx-react/card';
import { useA11y } from '@dsx-react/provider';
import { useFloating, autoUpdate, offset, flip, size } from '@floating-ui/react';
import { createPortal } from 'react-dom';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$b = ".CheckboxInput-module_checkbox__PHaoT {\n  -webkit-appearance: none;\n          appearance: none;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: var(--size-100);\n  height: 20px;\n  width: 20px;\n  display: grid;\n  place-content: center;\n}\n.CheckboxInput-module_checkbox__PHaoT:focus {\n  outline-style: solid;\n  outline-width: 2px;\n  outline-offset: 2px;\n  outline-color: var(--color-primary);\n}\n.CheckboxInput-module_checkbox__PHaoT:disabled {\n  opacity: 0.5;\n}\n.CheckboxInput-module_checkbox__PHaoT::before {\n  border-color: var(--color-neutral-50);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:enabled {\n  background-color: transparent;\n  border-color: var(--color-neutral-400);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:enabled:hover {\n  border-color: var(--color-neutral-500);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:enabled:active {\n  border-color: var(--color-neutral-600);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:enabled:checked, .CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:enabled:indeterminate {\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:enabled:checked:hover, .CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:enabled:indeterminate:hover {\n  background-color: var(--color-primary-600);\n  border-color: var(--color-primary-600);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:enabled:checked:active, .CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:enabled:indeterminate:active {\n  background-color: var(--color-primary-700);\n  border-color: var(--color-primary-700);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:disabled {\n  background-color: transparent;\n  border-color: var(--color-neutral-400);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:disabled:checked, .CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_default__5susU:disabled:indeterminate {\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:enabled {\n  background-color: transparent;\n  border-color: var(--color-danger);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:enabled:hover {\n  border-color: var(--color-danger);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:enabled:active {\n  border-color: var(--color-danger-600);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:enabled:checked, .CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:enabled:indeterminate {\n  background-color: var(--color-danger);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:enabled:checked:hover, .CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:enabled:indeterminate:hover {\n  background-color: var(--color-danger-600);\n  border-color: var(--color-danger-600);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:enabled:checked:active, .CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:enabled:indeterminate:active {\n  background-color: var(--color-danger-700);\n  border-color: var(--color-danger-700);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:disabled {\n  background-color: transparent;\n  border-color: var(--color-danger-400);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:disabled:checked, .CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:disabled:indeterminate {\n  background-color: var(--color-danger);\n  border-color: var(--color-danger);\n}\n.CheckboxInput-module_checkbox__PHaoT.CheckboxInput-module_danger__K02sJ:disabled::before {\n  border-color: var(--color-neutral-50);\n}\n.CheckboxInput-module_checkbox__PHaoT:checked:not(:indeterminate)::before {\n  content: \"\";\n  height: 1rem;\n  width: 0.6rem;\n  display: inline-block;\n  transform-origin: center;\n  transform: scale(0.75) translateY(-0.15rem) rotate(45deg);\n  border-bottom-width: 0.2rem;\n  border-bottom-style: solid;\n  border-right-width: 0.2rem;\n  border-right-style: solid;\n}\n.CheckboxInput-module_checkbox__PHaoT:indeterminate::before {\n  content: \"\";\n  height: 0.2rem;\n  width: 0.8rem;\n  display: inline-block;\n  transform-origin: center;\n  transform: scale(0.7) translateY(0.025rem);\n  border-bottom-width: 0.2rem;\n  border-bottom-style: solid;\n}\n\n.CheckboxInput-module_duel-checkbox__zcpbV {\n  -webkit-appearance: none;\n          appearance: none;\n  outline: none;\n  accent-color: var(--color-blue-600);\n  box-shadow: 0 0 0 var(--size-50) transparent;\n  transition: 50ms ease box-shadow;\n  border-radius: var(--size-50);\n  height: 1rem;\n  width: 1rem;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMinYMin meet' viewBox='0 0 24 24'%3E%3Cpath fill='%23677787' d='M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' /%3E%3C/svg%3E\");\n}\n.CheckboxInput-module_duel-checkbox__zcpbV:focus {\n  box-shadow: 0 0 0 var(--size-50) rgba(var(--color-blue-400-rgb), 0.4);\n}\n.CheckboxInput-module_duel-checkbox__zcpbV:checked {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMinYMin meet' viewBox='0 0 24 24'%3E%3Cpath fill='%230e8fff' d='M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' /%3E%3C/svg%3E\");\n}\n.CheckboxInput-module_duel-checkbox__zcpbV.CheckboxInput-module_danger__K02sJ:checked {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMinYMin meet' viewBox='0 0 24 24'%3E%3Cpath fill='%23c60c30' d='M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' /%3E%3C/svg%3E\");\n}\n.CheckboxInput-module_duel-checkbox__zcpbV:indeterminate {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMinYMin meet' viewBox='0 0 24 24'%3E%3Cpath fill='%230e8fff' d='M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' /%3E%3C/svg%3E\");\n}\n.CheckboxInput-module_duel-checkbox__zcpbV.CheckboxInput-module_danger__K02sJ:indeterminate {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMinYMin meet' viewBox='0 0 24 24'%3E%3Cpath fill='%23c60c30' d='M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' /%3E%3C/svg%3E\");\n}";
var styles$7 = {"checkbox":"CheckboxInput-module_checkbox__PHaoT","default":"CheckboxInput-module_default__5susU","danger":"CheckboxInput-module_danger__K02sJ","duel-checkbox":"CheckboxInput-module_duel-checkbox__zcpbV"};
styleInject(css_248z$b);

const CheckboxInput = /*#__PURE__*/forwardRef(
/**
 * A checkbox input that can be checked, unchecked, or indeterminate.
 */
function CheckboxInput(props, forwardedRef) {
  const {
    autoComplete = 'off',
    indeterminate,
    name,
    tag = name,
    variant = 'default',
    className: callerClassName,
    ...inputProps
  } = props;
  const ref = useRef();
  const checkboxStyle = useThemeVariable('UNSAFE-dsx-checkbox-style', ref);

  // Firefox has a rendering issue going from `appearance: none` to `appearance: auto`
  // during paint (the layout effect invoked in the `useThemeVariable` hook).
  // To avoid this, it's important to default to the native style when checkboxStyle
  // is undefined, rather than defaulting to the custom style.
  const useCustomVisuals = checkboxStyle === 'custom';
  useLayoutEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = !!indeterminate;
    }
  });
  const className = classNames('dsx-component', styles$7[variant], useCustomVisuals ? styles$7['duel-checkbox'] : styles$7['checkbox'], callerClassName);
  return /*#__PURE__*/jsx("input", {
    ...inputProps,
    name: name,
    type: "checkbox",
    className: className,
    ref: combineRefs(ref, forwardedRef),
    autoComplete: autoComplete,
    "data-dsx--checkbox-input": tag
  });
});

var css_248z$a = ".RadioInput-module_radio__ZqLAf {\n  -webkit-appearance: none;\n          appearance: none;\n  border-radius: 100%;\n  border-width: 1px;\n  border-style: solid;\n  background-color: transparent;\n  height: 20px;\n  width: 20px;\n  display: grid;\n  place-content: center;\n}\n.RadioInput-module_radio__ZqLAf:focus {\n  outline-style: solid;\n  outline-width: 2px;\n  outline-offset: 2px;\n  outline-color: var(--color-primary);\n}\n.RadioInput-module_radio__ZqLAf:disabled {\n  opacity: 0.5;\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:enabled {\n  background-color: transparent;\n  border-color: var(--color-neutral-400);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:enabled:hover {\n  border-color: var(--color-neutral-500);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:enabled:active {\n  border-color: var(--color-neutral-600);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:enabled:checked {\n  border-color: var(--color-primary);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:enabled:checked:hover {\n  border-color: var(--color-primary-600);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:enabled:checked:active {\n  border-color: var(--color-primary-700);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:enabled::before {\n  background-color: var(--color-primary);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:enabled::before:hover {\n  border-color: var(--color-primary-600);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:enabled::before:active {\n  border-color: var(--color-primary-700);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:disabled {\n  border-color: var(--color-neutral-400);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:disabled:checked {\n  border-color: var(--color-primary);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_default__wyJYT:disabled::before {\n  background-color: var(--color-primary);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_danger__bjfz5:enabled {\n  border-color: var(--color-danger);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_danger__bjfz5:enabled:hover {\n  border-color: var(--color-danger);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_danger__bjfz5:enabled:active {\n  border-color: var(--color-danger-600);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_danger__bjfz5:enabled:checked:hover {\n  border-color: var(--color-danger-600);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_danger__bjfz5:enabled:checked:active {\n  border-color: var(--color-danger-700);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_danger__bjfz5:enabled::before {\n  background-color: var(--color-danger);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_danger__bjfz5:enabled::before:hover {\n  background-color: var(--color-danger-600);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_danger__bjfz5:enabled::before:active {\n  background-color: var(--color-danger-700);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_danger__bjfz5:disabled {\n  background-color: transparent;\n  border-color: var(--color-danger-400);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_danger__bjfz5:disabled:checked {\n  border-color: var(--color-danger);\n}\n.RadioInput-module_radio__ZqLAf.RadioInput-module_danger__bjfz5:disabled::before {\n  background-color: var(--color-danger);\n}\n.RadioInput-module_radio__ZqLAf:checked::before {\n  content: \"\";\n  height: 10px;\n  width: 10px;\n  border-radius: 100%;\n  transform-origin: center;\n  display: inline-block;\n}\n\n.RadioInput-module_duel-radio__JHtaO {\n  -webkit-appearance: none;\n          appearance: none;\n  accent-color: var(--color-blue-600);\n  box-shadow: 0 0 0 var(--size-50) transparent;\n  transition: 50ms ease box-shadow;\n  height: 1rem;\n  width: 1rem;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMinYMin meet' viewBox='0 0 48 48'%3E%3Cpath fill='%23677787' d='M24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.8 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24 4q4.15 0 7.8 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Zm0-3q7.1 0 12.05-4.975Q41 31.05 41 24q0-7.1-4.95-12.05Q31.1 7 24 7q-7.05 0-12.025 4.95Q7 16.9 7 24q0 7.05 4.975 12.025Q16.95 41 24 41Zm0-17Z'/%3E%3C/svg%3E\");\n}\n\n.RadioInput-module_duel-radio__JHtaO:focus {\n  outline: none;\n  box-shadow: 0 0 0 var(--size-50) rgba(var(--color-blue-400-rgb), 0.4);\n}\n\n.RadioInput-module_duel-radio__JHtaO:checked {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMinYMin meet' viewBox='0 0 48 48'%3E%3Cpath fill='%230e8fff' d='M24 33.3q3.9 0 6.6-2.7 2.7-2.7 2.7-6.6 0-3.9-2.7-6.6-2.7-2.7-6.6-2.7-3.9 0-6.6 2.7-2.7 2.7-2.7 6.6 0 3.9 2.7 6.6 2.7 2.7 6.6 2.7ZM24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.8 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24 4q4.15 0 7.8 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Zm0-3q7.1 0 12.05-4.975Q41 31.05 41 24q0-7.1-4.95-12.05Q31.1 7 24 7q-7.05 0-12.025 4.95Q7 16.9 7 24q0 7.05 4.975 12.025Q16.95 41 24 41Zm0-17Z'/%3E%3C/svg%3E\");\n}";
var styles$6 = {"radio":"RadioInput-module_radio__ZqLAf","default":"RadioInput-module_default__wyJYT","danger":"RadioInput-module_danger__bjfz5","duel-radio":"RadioInput-module_duel-radio__JHtaO"};
styleInject(css_248z$a);

const RadioInput = /*#__PURE__*/forwardRef(function RadioInput(props, forwardedRef) {
  const {
    autoComplete = 'off',
    name,
    tag = name,
    variant = 'default',
    className: callerClassName,
    ...inputProps
  } = props;
  const ref = useRef();
  const checkboxStyle = useThemeVariable('UNSAFE-dsx-checkbox-style', ref);

  // Firefox has a rendering issue going from `appearance: none` to `appearance: auto`
  // during paint (the layout effect invoked in the `useThemeVariable` hook).
  // To avoid this, it's important to default to the native style when checkboxStyle
  // is undefined, rather than defaulting to the custom style.
  const useCustomVisuals = checkboxStyle === 'custom';
  const className = classNames('dsx-component', styles$6[variant], useCustomVisuals ? styles$6['duel-radio'] : styles$6['radio'], callerClassName);
  return /*#__PURE__*/jsx("input", {
    type: "radio",
    className: className,
    ref: combineRefs(ref, forwardedRef),
    autoComplete: autoComplete,
    "data-dsx--radio-input": tag,
    name: name,
    ...inputProps
  });
});

var css_248z$9 = ".ToggleInput-module_standalone__73ZRq {\n  display: flex;\n  gap: var(--size-200);\n  align-items: flex-start;\n}\n.ToggleInput-module_standalone__73ZRq .ToggleInput-module_toggle-track__63q7x {\n  margin-top: 2px;\n}\n\n.ToggleInput-module_hyphens__CVMUh {\n  white-space: wrap;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n\n.ToggleInput-module_grouped__E2rht {\n  display: flex;\n  gap: var(--size-200);\n  justify-content: space-between;\n}\n\n.ToggleInput-module_centered-container__0QQal {\n  display: flex;\n  align-items: center;\n  gap: var(--size-200);\n}\n\n.ToggleInput-module_toggle-track__63q7x:focus-within,\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_focus__zv-Fh {\n  outline: 2px solid var(--color-primary-500);\n}\n\n.ToggleInput-module_disabled__MNezJ:not(.ToggleInput-module_read-only__xI5LP) {\n  opacity: 0.5;\n}\n\n.ToggleInput-module_toggle-track__63q7x {\n  display: flex;\n  align-items: center;\n  width: 40px;\n  min-width: 40px;\n  height: 20px;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 999px;\n  outline-offset: 2px;\n  border-color: cyan;\n}\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_unchecked__Wi5-g {\n  background-color: var(--color-neutral-0);\n}\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_default__qZ-Lq.ToggleInput-module_unchecked__Wi5-g {\n  border-color: var(--color-neutral-800);\n}\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_default__qZ-Lq.ToggleInput-module_checked__eY059 {\n  border-color: var(--color-primary-500);\n  background-color: var(--color-primary-500);\n}\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_default__qZ-Lq.ToggleInput-module_checked__eY059.ToggleInput-module_enabled__60-Dw:where(:hover, .ToggleInput-module_hover__YZqYR) {\n  border-color: var(--color-primary-600);\n  background-color: var(--color-primary-600);\n}\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_default__qZ-Lq.ToggleInput-module_checked__eY059.ToggleInput-module_enabled__60-Dw:where(:active, .ToggleInput-module_active__ZHUT8) {\n  border-color: var(--color-primary-700);\n  background-color: var(--color-primary-700);\n}\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_danger__Ympvk {\n  border-color: var(--color-danger-500);\n}\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_danger__Ympvk.ToggleInput-module_checked__eY059 {\n  background-color: var(--color-danger-500);\n}\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_danger__Ympvk.ToggleInput-module_checked__eY059.ToggleInput-module_enabled__60-Dw:where(:hover, .ToggleInput-module_hover__YZqYR) {\n  background-color: var(--color-danger-600);\n}\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_danger__Ympvk.ToggleInput-module_checked__eY059.ToggleInput-module_enabled__60-Dw:where(:active, .ToggleInput-module_active__ZHUT8) {\n  background-color: var(--color-danger-700);\n}\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_read-only__xI5LP.ToggleInput-module_unchecked__Wi5-g {\n  background-color: var(--color-neutral-75);\n  border-color: var(--color-neutral-200);\n}\n.ToggleInput-module_toggle-track__63q7x.ToggleInput-module_read-only__xI5LP.ToggleInput-module_checked__eY059 {\n  background-color: var(--color-neutral-700);\n  border-color: var(--color-neutral-700);\n}\n\n.ToggleInput-module_toggle-input__v9zxm {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.ToggleInput-module_toggle-handle__IJoqn {\n  display: grid;\n  place-content: center;\n  border-radius: 9999px;\n  height: 14px;\n  width: 14px;\n  transform: translateX(2px);\n  transition: border-color 100ms ease-out, background-color 100ms ease-out, transform 100ms ease-out;\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_default__qZ-Lq.ToggleInput-module_unchecked__Wi5-g {\n  background-color: var(--color-neutral-500);\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_default__qZ-Lq.ToggleInput-module_checked__eY059 {\n  background-color: var(--color-neutral-0);\n  color: var(--color-primary-500);\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_default__qZ-Lq.ToggleInput-module_checked__eY059.ToggleInput-module_enabled__60-Dw:where(:hover, .ToggleInput-module_hover__YZqYR) {\n  color: var(--color-primary-600);\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_default__qZ-Lq.ToggleInput-module_checked__eY059.ToggleInput-module_enabled__60-Dw:where(:active, .ToggleInput-module_active__ZHUT8) {\n  color: var(--color-primary-700);\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_danger__Ympvk.ToggleInput-module_checked__eY059 {\n  color: var(--color-danger-500);\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_danger__Ympvk.ToggleInput-module_unchecked__Wi5-g {\n  background-color: var(--color-danger-500);\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_danger__Ympvk.ToggleInput-module_unchecked__Wi5-g.ToggleInput-module_enabled__60-Dw:where(:hover, .ToggleInput-module_hover__YZqYR) {\n  background-color: var(--color-danger-600);\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_danger__Ympvk.ToggleInput-module_unchecked__Wi5-g.ToggleInput-module_enabled__60-Dw:where(:active, .ToggleInput-module_active__ZHUT8) {\n  background-color: var(--color-danger-700);\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_read-only__xI5LP.ToggleInput-module_unchecked__Wi5-g {\n  background-color: var(--color-neutral-700);\n  color: var(--color-neutral-0);\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_read-only__xI5LP.ToggleInput-module_checked__eY059 {\n  background-color: var(--color-neutral-0);\n  color: var(--color-neutral-700);\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_unchecked__Wi5-g {\n  color: var(--color-neutral-0);\n}\n.ToggleInput-module_toggle-handle__IJoqn.ToggleInput-module_checked__eY059 {\n  background-color: var(--color-neutral-0);\n  transform: translateX(23px);\n}";
var styles$5 = {"standalone":"ToggleInput-module_standalone__73ZRq","toggle-track":"ToggleInput-module_toggle-track__63q7x","hyphens":"ToggleInput-module_hyphens__CVMUh","grouped":"ToggleInput-module_grouped__E2rht","centered-container":"ToggleInput-module_centered-container__0QQal","focus":"ToggleInput-module_focus__zv-Fh","disabled":"ToggleInput-module_disabled__MNezJ","read-only":"ToggleInput-module_read-only__xI5LP","unchecked":"ToggleInput-module_unchecked__Wi5-g","default":"ToggleInput-module_default__qZ-Lq","checked":"ToggleInput-module_checked__eY059","enabled":"ToggleInput-module_enabled__60-Dw","hover":"ToggleInput-module_hover__YZqYR","active":"ToggleInput-module_active__ZHUT8","danger":"ToggleInput-module_danger__Ympvk","toggle-input":"ToggleInput-module_toggle-input__v9zxm","toggle-handle":"ToggleInput-module_toggle-handle__IJoqn"};
styleInject(css_248z$9);

function ToggleInput(props) {
  const {
    checked,
    disabled,
    variant = 'default',
    UNSAFE_active,
    UNSAFE_focus,
    UNSAFE_hover,
    onClick
  } = props;
  const trackClassName = classNames(styles$5['toggle-track'], styles$5[variant], disabled ? styles$5['disabled'] : styles$5['enabled'], UNSAFE_active && styles$5['active'], UNSAFE_hover && styles$5['hover'], UNSAFE_focus && styles$5['focus'], checked ? styles$5['checked'] : styles$5['unchecked']);
  const handleClassName = classNames(styles$5['toggle-handle'], styles$5[variant], UNSAFE_active && styles$5['active'], UNSAFE_hover && styles$5['hover'], UNSAFE_focus && styles$5['focus'], checked ? styles$5['checked'] : styles$5['unchecked']);
  const handleIcon = checked ? /*#__PURE__*/jsx(MdCheck, {
    size: "12px"
  }) : /*#__PURE__*/jsx(MdClose, {
    size: "12px"
  });
  return /*#__PURE__*/jsxs("div", {
    className: trackClassName,
    children: [/*#__PURE__*/jsx("input", {
      type: "checkbox",
      className: styles$5['toggle-input'],
      checked: checked,
      disabled: disabled,
      onChange: onClick,
      onKeyDown: e => {
        if (e.key === 'Enter') {
          onClick();
        }
      }
    }), /*#__PURE__*/jsx("span", {
      className: handleClassName,
      children: handleIcon
    })]
  });
}

var required$1 = "requir'd";
var optional$1 = "option'l";
var today$1 = "T'day";
var Search$1 = "Sail";
var Expand$1 = "Elaborate";
var Year$1 = "Year";
var Month$1 = "Month";
var Help$1 = "SOS";
var Success$1 = "Victory";
var Warning$1 = "A fell wind";
var Upload$1 = "Board";
var Remove$1 = "Scuttle";
var Cancel$1 = "Abandon";
var On$1 = "Ahoy";
var Off$1 = "Avast";
var Clear$1 = "Fall back";
var enPT = {
	required: required$1,
	optional: optional$1,
	today: today$1,
	"next-month": "Followin' month",
	"previous-month": "Precedin' month",
	"No results": "There be nothin' here fer ye",
	"No results for <q>{search}</q>": "There be nothin' here fer <q>{search}</q>",
	Search: Search$1,
	Expand: Expand$1,
	"Searching...": "Sailin' the seas...",
	"Searching for <q>{search}</q>": "Sailin' the seas fer <q>{search}</q>",
	"There was a problem completing your search": "Yer vessel has capsized along th' way",
	"Try again": "Sail again",
	"{count} selected": "{count} chos'n",
	Year: Year$1,
	Month: Month$1,
	"Start year": "Beginnin' year",
	"Start month": "Beginnin' month",
	"End year": "Endin' year",
	"End month": "Endin' month",
	"Select all": "Take 'em all",
	Help: Help$1,
	Success: Success$1,
	Warning: Warning$1,
	"Error": "Mayday",
	Upload: Upload$1,
	Remove: Remove$1,
	"Choose file": "Seek file",
	"Drag and drop files here to upload or <q>browse files</q>.": "Drag 'n' drop yer files here to upload or <q>seek files elsewhere</q>.",
	"No file chosen": "Pick a document, matey",
	"Accepted formats: {list}": "Accept'd cargo: {list}",
	Cancel: Cancel$1,
	"Send message": "Send missive",
	On: On$1,
	Off: Off$1,
	Clear: Clear$1
};

var required = "required";
var optional = "optional";
var today = "Today";
var Search = "Search";
var Expand = "Expand";
var Year = "Year";
var Month = "Month";
var Help = "Help";
var Success = "Success";
var Warning = "Warning";
var Upload = "Upload";
var Remove = "Remove";
var Cancel = "Cancel";
var On = "On";
var Off = "Off";
var Clear = "Clear";
var enUS = {
	required: required,
	optional: optional,
	today: today,
	"next-month": "Next month",
	"previous-month": "Previous month",
	"No results": "No results",
	"No results for <q>{search}</q>": "No results for <q>{search}</q>",
	Search: Search,
	Expand: Expand,
	"Searching...": "Searching...",
	"Searching for <q>{search}</q>": "Searching for <q>{search}</q>",
	"There was a problem completing your search": "There was a problem completing your search",
	"Try again": "Try again",
	"{count} selected": "{count} selected",
	Year: Year,
	Month: Month,
	"Start year": "Start year",
	"Start month": "Start month",
	"End year": "End year",
	"End month": "End month",
	"Select all": "Select all",
	Help: Help,
	Success: Success,
	Warning: Warning,
	"Error": "Error",
	Upload: Upload,
	Remove: Remove,
	"Choose file": "Choose file",
	"Drag and drop files here to upload or <q>browse files</q>.": "Drag and drop files here to upload or <q>browse files</q>.",
	"No file chosen": "No file chosen",
	"Accepted formats: {list}": "Accepted formats: {list}",
	Cancel: Cancel,
	"Send message": "Send message",
	On: On,
	Off: Off,
	Clear: Clear
};

const messages = {
  'en-US': enUS,
  'en-PT': enPT
};
var messages$1 = messages;

var css_248z$8 = ".Inputs-module_input-box__yCK-W {\n  --color-border: transparent;\n  background-color: var(--color-neutral-0);\n  border: 1px solid var(--color-border);\n  border-radius: var(--border-radius-default);\n  width: 100%;\n  margin: 0;\n  padding: var(--padding-y) var(--padding-x);\n  font-family: inherit;\n  line-height: 1.5;\n}\n\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W {\n  --padding-y: 0.625rem;\n  --padding-x: 0.625rem;\n  color: var(--color-neutral-800);\n  transition: 30ms ease border;\n  font-size: 1rem;\n  letter-spacing: var(--letter-spacing-16);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_with-button__IFaGV {\n  --padding-y: var(--size-150);\n  --padding-x: var(--size-150);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw {\n  --color-border: var(--color-neutral-400);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw:focus-visible {\n  --color-border: var(--color-primary-100);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw:focus-within {\n  --color-border: var(--color-primary-100);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw.Inputs-module_focus__hEXVk {\n  --color-border: var(--color-primary-100);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw:hover:enabled {\n  --color-border: var(--color-neutral-500);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw.Inputs-module_hover__irHRk:enabled {\n  --color-border: var(--color-neutral-500);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw:active:enabled {\n  --color-border: var(--color-neutral-600);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw.Inputs-module_active__taFvs:enabled {\n  --color-border: var(--color-neutral-600);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv {\n  --color-border: var(--color-danger-500);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv:focus-visible {\n  --color-border: var(--color-danger-100);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv:focus-within {\n  --color-border: var(--color-danger-100);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv.Inputs-module_focus__hEXVk {\n  --color-border: var(--color-danger-100);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv:hover:enabled {\n  --color-border: var(--color-danger-600);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv.Inputs-module_hover__irHRk:enabled {\n  --color-border: var(--color-danger-600);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv:active:enabled {\n  --color-border: var(--color-danger-700);\n}\n:where(.dsx-theme-default) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv.Inputs-module_active__taFvs:enabled {\n  --color-border: var(--color-danger-700);\n}\n\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W {\n  --padding-y: var(--size-200);\n  --padding-x: var(--size-300);\n  color: #444;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  transition: 120ms ease box-shadow, 30ms ease border;\n  font-size: 0.875rem;\n  letter-spacing: var(--letter-spacing-14);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W.Inputs-module_with-button__IFaGV {\n  --padding-y: var(--size-150);\n  --padding-x: var(--size-150);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W:focus-visible {\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.16), 0 0 10px 0 rgba(0, 0, 0, 0.12);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W:focus-within {\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.16), 0 0 10px 0 rgba(0, 0, 0, 0.12);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W.Inputs-module_focus__hEXVk {\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.16), 0 0 10px 0 rgba(0, 0, 0, 0.12);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw {\n  --color-border: rgba(var(--color-gray-500-rgb), 0.25);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw:focus-visible {\n  --color-border: var(--color-primary-500);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw:focus-within {\n  --color-border: var(--color-primary-500);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W.Inputs-module_default__dnznw.Inputs-module_focus__hEXVk {\n  --color-border: var(--color-primary-500);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv:focus-visible {\n  --color-border: var(--color-danger-500);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv:focus-within {\n  --color-border: var(--color-danger-500);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv.Inputs-module_focus__hEXVk {\n  --color-border: var(--color-danger-500);\n}\n:where(.dsx-theme-legacy) .Inputs-module_input-box__yCK-W.Inputs-module_danger__zmzxv {\n  --color-border: var(--color-danger-500);\n}\n\n.Inputs-module_input-box__yCK-W:focus-visible {\n  outline: 2px solid var(--color-primary-500);\n}\n\n.Inputs-module_input-box__yCK-W:focus-within {\n  outline: 2px solid var(--color-primary-500);\n}\n\n.Inputs-module_input-box__yCK-W.Inputs-module_focus__hEXVk {\n  outline: 2px solid var(--color-primary-500);\n}\n\n.Inputs-module_input-box__yCK-W:disabled {\n  opacity: 0.4;\n  pointer-events: none;\n}\n\ninput.Inputs-module_input-box__yCK-W.Inputs-module_input__pmmVS:read-only:enabled {\n  color: var(--color-gray-700);\n  background-color: var(--color-gray-75);\n  --color-border: transparent;\n}\n\ntextarea.Inputs-module_input-box__yCK-W.Inputs-module_input__pmmVS:read-only:enabled {\n  color: var(--color-gray-700);\n  background-color: var(--color-gray-75);\n  --color-border: transparent;\n}\n\n.Inputs-module_input-box__yCK-W.Inputs-module_read-only__BWwro:enabled {\n  color: var(--color-gray-700);\n  background-color: var(--color-gray-75);\n  --color-border: transparent;\n}\n\n.Inputs-module_input__pmmVS {\n  width: 100%;\n}\n\ntextarea.Inputs-module_input__pmmVS {\n  resize: none;\n  overflow-x: hidden;\n}\n\ninput[type=date].Inputs-module_input__pmmVS,\ninput[type=datetime-local].Inputs-module_input__pmmVS,\ninput[type=month].Inputs-module_input__pmmVS,\ninput[type=time].Inputs-module_input__pmmVS {\n  -webkit-appearance: none;\n          appearance: none;\n}\n\n.Inputs-module_input__pmmVS::placeholder {\n  color: var(--color-neutral-500);\n}\n\n.Inputs-module_input-box__yCK-W .Inputs-module_input__pmmVS {\n  color: inherit;\n  border: none;\n  outline: none;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  background: transparent;\n}\n\n.Inputs-module_sub-input__tZKvW:focus-visible {\n  background-color: var(--color-primary-100);\n}\n\n.Inputs-module_container__hZU2S {\n  display: flex;\n  flex-direction: row;\n  gap: var(--size-100);\n  align-items: center;\n}\n\n.Inputs-module_container__hZU2S .Inputs-module_input__pmmVS {\n  height: 1.5rem;\n  padding: 0;\n}\n\n.Inputs-module_container__hZU2S.Inputs-module_with-button__IFaGV .Inputs-module_input__pmmVS {\n  height: 2rem;\n  padding: var(--size-100);\n}\n\n.Inputs-module_container__hZU2S.Inputs-module_with-button__IFaGV .Inputs-module_text-wrapper__UWiEW {\n  padding: var(--size-100);\n}\n\n.Inputs-module_input-box__yCK-W.Inputs-module_multi-container__Z0Gzc {\n  display: flex;\n  flex-direction: row;\n  padding: 0;\n}\n\n.Inputs-module_input-box__yCK-W.Inputs-module_multi-container__Z0Gzc > * {\n  flex: 1 1 0%;\n  min-width: 2rem;\n  padding: var(--padding-y) var(--padding-x);\n}\n\n.Inputs-module_input-box__yCK-W.Inputs-module_multi-container__Z0Gzc > :not(:first-child) {\n  border-left: 1px solid var(--color-border);\n}\n\n.Inputs-module_arrow-wrapper__qAn7q {\n  position: relative;\n}\n\n.Inputs-module_arrow-input__iAe6t {\n  -webkit-appearance: none;\n          appearance: none;\n  padding-right: calc(var(--arrow-margin-x) + var(--arrow-padding-x) * 2 + var(--arrow-size));\n}\n\n.Inputs-module_arrow__rir-G {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  right: 1px;\n  top: 1px;\n  bottom: 1px;\n  padding: 0 var(--arrow-padding-x);\n  margin: var(--arrow-padding-y) 0;\n  pointer-events: none;\n}\n\n.Inputs-module_arrow__rir-G svg {\n  width: var(--arrow-size);\n  height: var(--arrow-size);\n}\n\n:where(.dsx-theme-default) .Inputs-module_arrow-wrapper__qAn7q {\n  --arrow-padding-x: 0.625rem;\n  --arrow-padding-y: 0.625rem;\n  --arrow-margin-x: 0rem;\n  --arrow-size: 1.5rem;\n}\n\n:where(.dsx-theme-legacy) .Inputs-module_arrow-wrapper__qAn7q {\n  --arrow-padding-x: 0.5rem;\n  --arrow-padding-y: 0.5rem;\n  --arrow-margin-x: var(--size-300);\n  --arrow-size: 1.25rem;\n}\n:where(.dsx-theme-legacy) .Inputs-module_arrow__rir-G {\n  border-left: 1px solid #ddd;\n  color: #ddd;\n}\n:where(.dsx-theme-legacy) .Inputs-module_arrow-wrapper__qAn7q:focus-within .Inputs-module_arrow__rir-G {\n  color: #777;\n}\n\n.Inputs-module_input-box__yCK-W.Inputs-module_chat-input__EQRv4 textarea.Inputs-module_input__pmmVS {\n  max-height: calc(var(--max-lines, 6) * 1.5rem + 2 * var(--size-100));\n}\n\n.Inputs-module_divider__px2ed {\n  width: 1px;\n  height: 1.5rem;\n  align-self: center;\n  background-color: var(--color-neutral-200);\n}\n\n.Inputs-module_cursor-text__TVFi8 {\n  cursor: text;\n}\n\n.Inputs-module_start__p-lFk {\n  text-align: left;\n}\n\n.Inputs-module_end__3Bmuz {\n  text-align: right;\n}\n\n.Inputs-module_tabular-nums__L75Kw {\n  font-feature-settings: \"tnum\";\n  font-variant-numeric: tabular-nums;\n}\n\n.Inputs-module_loading__YqpCD::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\n.Inputs-module_width-auto__Xn09z {\n  width: auto;\n}\n\n.Inputs-module_appearance-none__QaMnT {\n  -webkit-appearance: none;\n          appearance: none;\n}\n\n.Inputs-module_align-end__xjh2O {\n  align-self: flex-end;\n}\n\n.Inputs-module_shrink-0__MqLc2 {\n  flex-shrink: 0;\n}";
var styles$4 = {"input-box":"Inputs-module_input-box__yCK-W","with-button":"Inputs-module_with-button__IFaGV","default":"Inputs-module_default__dnznw","focus":"Inputs-module_focus__hEXVk","hover":"Inputs-module_hover__irHRk","active":"Inputs-module_active__taFvs","danger":"Inputs-module_danger__zmzxv","input":"Inputs-module_input__pmmVS","read-only":"Inputs-module_read-only__BWwro","sub-input":"Inputs-module_sub-input__tZKvW","container":"Inputs-module_container__hZU2S","text-wrapper":"Inputs-module_text-wrapper__UWiEW","multi-container":"Inputs-module_multi-container__Z0Gzc","arrow-wrapper":"Inputs-module_arrow-wrapper__qAn7q","arrow-input":"Inputs-module_arrow-input__iAe6t","arrow":"Inputs-module_arrow__rir-G","chat-input":"Inputs-module_chat-input__EQRv4","divider":"Inputs-module_divider__px2ed","cursor-text":"Inputs-module_cursor-text__TVFi8","start":"Inputs-module_start__p-lFk","end":"Inputs-module_end__3Bmuz","tabular-nums":"Inputs-module_tabular-nums__L75Kw","loading":"Inputs-module_loading__YqpCD","width-auto":"Inputs-module_width-auto__Xn09z","appearance-none":"Inputs-module_appearance-none__QaMnT","align-end":"Inputs-module_align-end__xjh2O","shrink-0":"Inputs-module_shrink-0__MqLc2"};
styleInject(css_248z$8);

const SearchBar = /*#__PURE__*/forwardRef(function SearchBar(props, forwardedRef) {
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const {
    autoComplete = 'off',
    className: callerClassName,
    disabled,
    name,
    readOnly,
    scope: callerScope,
    scopeOptions,
    search: callerSearch,
    tag = name,
    variant = 'default',
    onScopeChange: callerOnScopeChange,
    onSearch,
    onSearchChange: callerOnSearchChange,
    ...inputProps
  } = props;
  const ref = useRef(null);
  const [scope, onScopeChange] = useControllableState(callerScope, '', callerOnScopeChange);
  const [search, onSearchChange] = useControllableState(callerSearch, '', callerOnSearchChange);
  function handleSearchChange(e) {
    onSearchChange(e.currentTarget.value);
  }
  function handleSearchKeyDown(e) {
    if (e.key === 'Enter') {
      handleSearch();
    }
  }
  function handleSearch() {
    if (scopeOptions) {
      onSearch === null || onSearch === void 0 || onSearch(search ?? '', scope ?? '');
    } else {
      onSearch === null || onSearch === void 0 || onSearch(search ?? '');
    }
  }
  function handleClear() {
    onSearchChange('');
  }
  function handleClick() {
    var _ref$current;
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
  }
  function handleMouseDown(e) {
    if (e.target !== ref.current) {
      e.preventDefault();
    }
  }
  function stopPropagation(e) {
    e.stopPropagation();
  }
  const containerClassName = classNames('dsx-component', styles$4['input-box'], styles$4['with-button'], styles$4['container'], styles$4['cursor-text'], styles$4[variant], readOnly && styles$4['read-only'], callerClassName);
  const inputClassName = classNames(styles$4['input']);
  return /*#__PURE__*/jsxs("fieldset", {
    className: containerClassName,
    disabled: disabled,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    children: [scopeOptions && /*#__PURE__*/jsx("span", {
      className: styles$4['shrink-0'],
      onClick: stopPropagation,
      onMouseDown: stopPropagation,
      children: /*#__PURE__*/jsx(Menu, {
        anchor: props => {
          var _scopeOptions$find;
          return /*#__PURE__*/jsx(Button, {
            ...props,
            actionIndicator: "MdKeyboardArrowDown",
            size: "compact",
            variant: "ui-control",
            children: ((_scopeOptions$find = scopeOptions.find(option => option.value === scope)) === null || _scopeOptions$find === void 0 ? void 0 : _scopeOptions$find.label) ?? ''
          });
        },
        onSelect: onScopeChange,
        children: scopeOptions.map(option => /*#__PURE__*/jsx(MenuItem, {
          disabled: option.disabled,
          selected: option.value === scope,
          value: option.value,
          children: option.label
        }, option.value))
      })
    }), /*#__PURE__*/jsx("input", {
      ...inputProps,
      autoComplete: autoComplete,
      className: inputClassName,
      name: name,
      readOnly: readOnly,
      ref: combineRefs(forwardedRef, ref),
      type: "text",
      value: search,
      onChange: handleSearchChange,
      onKeyDown: handleSearchKeyDown,
      "data-dsx--search-bar--search": tag
    }), search && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Button, {
        iconOnly: true,
        icon: MdClear,
        size: "compact",
        variant: "ui-control",
        onClick: handleClear,
        children: formatMessage('Clear')
      }), /*#__PURE__*/jsx("span", {
        className: styles$4['divider']
      })]
    }), /*#__PURE__*/jsx(Button, {
      className: styles$4['align-end'],
      iconOnly: true,
      icon: MdSearch,
      size: "compact",
      variant: "ui-control",
      onClick: handleSearch,
      children: formatMessage('Search')
    })]
  });
});

var css_248z$7 = ".DatePickerInput-module_date-picker__JuQ4Q {\n  display: flex;\n  flex-direction: column;\n  border: 2px solid transparent;\n  max-width: 26rem;\n}\n\n.DatePickerInput-module_danger__FBgL9 {\n  border: 2px solid var(--color-danger-500);\n  border-radius: 4px;\n}\n\n.DatePickerInput-module_default__YDj6- {\n  border: 2px solid transparent;\n  border-radius: 4px;\n}\n\n.DatePickerInput-module_month__hSRsG {\n  display: table;\n  align-self: center;\n  margin-top: var(--size-300);\n}\n\n.DatePickerInput-module_month__hSRsG button {\n  width: 100%;\n}\n\n.DatePickerInput-module_week__PHo6y {\n  display: table-row;\n}\n\n.DatePickerInput-module_day-of-week__W62Ew {\n  display: table-cell;\n  padding: var(--size-200);\n  text-align: center;\n}\n\n.DatePickerInput-module_day__6UujF {\n  display: table-cell;\n  padding: var(--size-100);\n}\n\n.DatePickerInput-module_controls__LljwI {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.DatePickerInput-module_today-container__kxfiH {\n  display: flex;\n  justify-content: flex-end;\n}";
var styles$3 = {"date-picker":"DatePickerInput-module_date-picker__JuQ4Q","danger":"DatePickerInput-module_danger__FBgL9","default":"DatePickerInput-module_default__YDj6-","month":"DatePickerInput-module_month__hSRsG","week":"DatePickerInput-module_week__PHo6y","day-of-week":"DatePickerInput-module_day-of-week__W62Ew","day":"DatePickerInput-module_day__6UujF","controls":"DatePickerInput-module_controls__LljwI","today-container":"DatePickerInput-module_today-container__kxfiH"};
styleInject(css_248z$7);

function isValidDate(input) {
  // 30 days has September, April, June, and November
  // All the rest have 31
  // Except February :(
  // Use Date.parse to deal with leap years and special cases
  return (/^\d{4}-(0[469]|11)-(0[1-9]|[12][0-9]|30)$/.test(input) || /^\d{4}-(0[^2469]|1[02])-(0[1-9]|[12][0-9]|3[01])$/.test(input) || /^\d{4}-02-(0[1-9]|1[0-9]|2[0-9])$/.test(input)) && !Number.isNaN(Date.parse(input));
}
function isValidDateTime(input) {
  // Dates and
  // 00:00 to 24:00
  return (/^\d{4}-(0[469]|11)-(0[1-9]|[12][0-9]|30)T(([01][0-9]|2[0-3]):([0-5][0-9])|24:00)$/.test(input) || /^\d{4}-(0[^2469]|1[02])-(0[1-9]|[12][0-9]|3[01])T(([01][0-9]|2[0-3]):([0-5][0-9])|24:00)$/.test(input) || /^\d{4}-02-(0[1-9]|2[0-9])T(([01][0-9]|2[0-3]):([0-5][0-9])|24:00)$/.test(input)) && !Number.isNaN(Date.parse(input));
}
function parseLocalDate(input) {
  if (!input) {
    return undefined;
  }
  if (input === 'today') {
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    return today;
  }
  if (input === 'tomorrow') {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  }
  if (input === 'yesterday') {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  }
  if (isValidDate(input)) {
    return new Date(`${input}T00:00:00`); // Append time to force local evaluation
  } else {
    console.warn(`Failed to parse "${input}" as LocalDate. Ensure that your value is in the format "yyyy-MM-dd"`);
    return undefined;
  }
}
function parseLocalDateTime(input) {
  if (!input) {
    return undefined;
  }
  if (input === 'today') {
    return new Date();
  }
  if (input === 'tomorrow') {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  }
  if (input === 'yesterday') {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  }
  if (isValidDateTime(input)) {
    return new Date(input);
  } else {
    console.warn(`Failed to parse "${input}" as LocalDate. Ensure that your value is in the format "yyyy-MM-ddThh:mm"`);
    return undefined;
  }
}
function localDateToLocalIsoString(date) {
  const formatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  };
  const formatter = Intl.DateTimeFormat(undefined, formatOptions);
  const parts = formatter.formatToParts(date).reduce((agg, curr) => {
    if (curr.type in formatOptions) {
      agg[curr.type] = curr.value;
    }
    return agg;
  }, {});
  return `${parts.year}-${parts.month}-${parts.day}`;
}
function localDateTimeToLocalIsoString(date) {
  const formatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  };
  const formatter = Intl.DateTimeFormat(undefined, formatOptions);
  const parts = formatter.formatToParts(date).reduce((agg, curr) => {
    if (curr.type in formatOptions) {
      agg[curr.type] = curr.value;
    }
    return agg;
  }, {});
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

function DatePickerInput(props) {
  const {
    className: callerClassName,
    initialDisplayedMonth,
    value,
    onChange,
    variant = 'default',
    tag,
    min,
    max,
    exclude = noop
  } = props;
  const defaultDisplayedMonth = parseLocalDate(initialDisplayedMonth || 'today');
  // Why .setDate(5)
  // The calendarize function is based on the native Date implementation,
  // which means things are done with respect to the viewer's time zone,
  // and can lead to displaying the "previous" month if you use the first day.
  // (for example, 2021-01-01 is interpreted as 2020-12-31T18:00 in -6 Milwaukee.)
  defaultDisplayedMonth.setDate(5);
  const [displayedMonth, setDisplayedMonth] = useState(defaultDisplayedMonth);
  const minAsDate = parseLocalDate(min);
  const maxAsDate = parseLocalDate(max);
  const valueAsDate = parseLocalDate(value);

  // TODO(chriswil): Use DSX DateTime components to display current month.
  // const title = currentMonthView.format(DateTimeFormatter.ofPattern('MMM YYYY'))
  const title = displayedMonth.toLocaleString('default', {
    month: 'long',
    year: 'numeric'
  });
  const calendar = calendarize(displayedMonth);
  function handleDateChange(thisDayAsString) {
    return () => {
      if (!onChange) {
        return;
      }
      const eventValue = thisDayAsString === value ? undefined : thisDayAsString;
      onChange(eventValue);
    };
  }
  const weeks = calendar.map((w, i) => {
    const days = w.map((d, j) => {
      let el = undefined;
      if (d > 0) {
        const thisDayAsDate = new Date(displayedMonth);
        thisDayAsDate.setDate(d);
        const thisDayAsString = localDateToLocalIsoString(thisDayAsDate);
        const isThisDaySelected = thisDayAsDate.valueOf() === (valueAsDate === null || valueAsDate === void 0 ? void 0 : valueAsDate.valueOf());
        const meetsMinimum = minAsDate ? thisDayAsDate.valueOf() === minAsDate.valueOf() || thisDayAsDate.valueOf() > minAsDate.valueOf() : true;
        const meetsMaximum = maxAsDate ? thisDayAsDate.valueOf() === maxAsDate.valueOf() || thisDayAsDate.valueOf() < maxAsDate.valueOf() : true;
        const isExcluded = exclude(thisDayAsString);
        const inRange = meetsMinimum && meetsMaximum && !isExcluded;
        const variant = isThisDaySelected ? 'primary' : 'ui-control';
        el = /*#__PURE__*/jsx(Button, {
          disabled: !inRange,
          "data-dsx--date-picker-input--day": `${tag}-${thisDayAsString}`,
          variant: variant,
          onClick: handleDateChange(thisDayAsString),
          type: "button",
          children: d.toString()
        });
      }
      return /*#__PURE__*/jsx("div", {
        className: styles$3['day'],
        children: el
      }, j);
    });
    return /*#__PURE__*/jsx("div", {
      className: styles$3['week'],
      children: days
    }, i);
  });
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const daysOfWeek = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'].map(d => {
    // TODO(chriswil): Use DSX DateTime components to display day of week.
    return /*#__PURE__*/jsx("div", {
      className: styles$3['day-of-week'],
      children: d[0]
    }, `day-of-week-${d.toLocaleLowerCase()}`);
  });
  weeks.unshift( /*#__PURE__*/jsx("div", {
    className: styles$3['week'],
    children: daysOfWeek
  }, "heading"));
  function handleNextMonth() {
    const nextMonth = new Date(displayedMonth);
    nextMonth.setMonth(displayedMonth.getMonth() + 1);
    setDisplayedMonth(nextMonth);
  }
  function handlePreviousMonth() {
    const previousMonth = new Date(displayedMonth);
    previousMonth.setMonth(displayedMonth.getMonth() - 1);
    setDisplayedMonth(previousMonth);
  }
  function handleToday() {
    const todaysMonth = parseLocalDate('today');
    todaysMonth.setDate(5);
    setDisplayedMonth(todaysMonth);
  }
  const className = classNames('dsx-component', styles$3['date-picker'], styles$3[variant], callerClassName);
  return /*#__PURE__*/jsxs("div", {
    className: className,
    "data-dsx--date-picker-input": tag,
    children: [/*#__PURE__*/jsxs("div", {
      className: styles$3['controls'],
      children: [/*#__PURE__*/jsx(Button, {
        type: "button",
        icon: MdNavigateBefore,
        iconOnly: true,
        variant: "ui-control",
        onClick: handlePreviousMonth,
        "data-dsx--date-picker-input--prev": tag,
        children: formatMessage('previous-month')
      }), /*#__PURE__*/jsx(Text, {
        children: title
      }), /*#__PURE__*/jsx(Button, {
        type: "button",
        icon: MdNavigateNext,
        iconOnly: true,
        variant: "ui-control",
        onClick: handleNextMonth,
        "data-dsx--date-picker-input--next": tag,
        children: formatMessage('next-month')
      })]
    }), /*#__PURE__*/jsx("div", {
      className: styles$3['month'],
      children: weeks
    }), /*#__PURE__*/jsx("div", {
      className: styles$3['today-container'],
      children: /*#__PURE__*/jsx(Button, {
        onClick: handleToday,
        variant: "ui-control",
        icon: MdToday,
        children: formatMessage('today')
      })
    })]
  });
}
function noop() {
  return false;
}

/**
 * Allows the user to input a local date.
 */
const LocalDateInput = /*#__PURE__*/forwardRef(function LocalDateInput(props, forwardedRef) {
  const {
    className: callerClassName,
    max,
    min,
    readOnly,
    tag,
    value,
    variant = 'default',
    onChange,
    UNSAFE_active,
    UNSAFE_focus,
    UNSAFE_hover,
    ...inputProps
  } = props;
  const className = classNames('dsx-component', styles$4['input-box'], styles$4['input'], styles$4['tabular-nums'], styles$4[variant], readOnly && styles$4['read-only'], UNSAFE_hover && styles$4['hover'], UNSAFE_active && styles$4['active'], UNSAFE_focus && styles$4['focus'], callerClassName);
  function handleChange(e) {
    onChange(e.currentTarget.value);
  }
  const minLdt = parseLocalDate(min);
  const maxLdt = parseLocalDate(max);
  return /*#__PURE__*/jsx("input", {
    ...inputProps,
    className: className,
    max: maxLdt && localDateToLocalIsoString(maxLdt),
    min: minLdt && localDateToLocalIsoString(minLdt),
    readOnly: readOnly,
    ref: forwardedRef,
    type: "date",
    value: value,
    onChange: handleChange,
    "data-dsx--local-date-input": tag
  });
});

/**
 * Allows the user to input a local date.
 */
function LocalDateRangeInput(props) {
  const {
    className: callerClassName,
    disabled,
    max,
    min,
    readOnly,
    tag,
    value,
    variant = 'default',
    onChange,
    ...inputProps
  } = props;
  const containerClassName = classNames('dsx-component', styles$4['input-box'], styles$4['multi-container'], styles$4[variant], readOnly && styles$4['read-only'], callerClassName);
  const inputClassName = classNames(styles$4['input'], styles$4['tabular-nums']);
  const startRef = useRef(null);
  const endRef = useRef(null);
  const [startVal, endVal] = value.split('/');
  function handleChange() {
    const startVal = startRef.current.value;
    const endVal = endRef.current.value;
    const val = `${startVal}/${endVal}`;
    onChange(val);
  }
  const minLdt = parseLocalDate(min);
  const maxLdt = parseLocalDate(max);
  return /*#__PURE__*/jsxs("fieldset", {
    className: containerClassName,
    disabled: disabled,
    children: [/*#__PURE__*/jsx("input", {
      ...inputProps,
      className: inputClassName,
      max: maxLdt && localDateToLocalIsoString(maxLdt),
      min: minLdt && localDateToLocalIsoString(minLdt),
      placeholder: "begin",
      readOnly: readOnly,
      ref: startRef,
      type: "date",
      value: startVal,
      onChange: handleChange,
      "data-dsx--local-date-range-input--start": tag
    }), /*#__PURE__*/jsx("input", {
      ...inputProps,
      className: inputClassName,
      max: maxLdt && localDateToLocalIsoString(maxLdt),
      min: minLdt && localDateToLocalIsoString(minLdt),
      placeholder: "end",
      readOnly: readOnly,
      ref: endRef,
      type: "date",
      value: endVal,
      onChange: handleChange,
      "data-dsx--local-date-range-input--end": tag
    })]
  });
}

/**
 * Allows the user to input a local datetime.
 */
const LocalDateTimeInput = /*#__PURE__*/forwardRef(function LocalDateTimeInput(props, ref) {
  const {
    className: callerClassName,
    max,
    min,
    readOnly,
    step = 5 * 60,
    tag,
    value,
    variant = 'default',
    onChange,
    UNSAFE_active,
    UNSAFE_focus,
    UNSAFE_hover,
    ...inputProps
  } = props;
  const className = classNames('dsx-component', styles$4['input-box'], styles$4['input'], styles$4['tabular-nums'], styles$4[variant], readOnly && styles$4['read-only'], UNSAFE_hover && styles$4['hover'], UNSAFE_active && styles$4['active'], UNSAFE_focus && styles$4['focus'], callerClassName);
  function handleChange(e) {
    onChange(e.currentTarget.value);
  }
  const minLdt = parseLocalDateTime(min);
  const maxLdt = parseLocalDateTime(max);
  return /*#__PURE__*/jsx("input", {
    ...inputProps,
    className: className,
    max: maxLdt && localDateTimeToLocalIsoString(maxLdt),
    min: minLdt && localDateTimeToLocalIsoString(minLdt),
    readOnly: readOnly,
    ref: ref,
    step: step,
    type: "datetime-local",
    value: value,
    onChange: handleChange,
    "data-dsx--local-date-time-input": tag
  });
});

/**
 * Allows the user to input a local time.
 */
const LocalTimeInput = /*#__PURE__*/forwardRef(function LocalTimeInput(props, ref) {
  const {
    className: callerClassName,
    readOnly,
    tag,
    value,
    variant = 'default',
    onChange,
    UNSAFE_active,
    UNSAFE_focus,
    UNSAFE_hover,
    ...inputProps
  } = props;
  const className = classNames('dsx-component', styles$4['input-box'], styles$4['input'], styles$4['tabular-nums'], styles$4[variant], readOnly && styles$4['read-only'], UNSAFE_hover && styles$4['hover'], UNSAFE_active && styles$4['active'], UNSAFE_focus && styles$4['focus'], callerClassName);
  function handleChange(e) {
    onChange(e.currentTarget.value);
  }
  return /*#__PURE__*/jsx("input", {
    ...inputProps,
    className: className,
    readOnly: readOnly,
    ref: ref,
    type: "time",
    value: value,
    onChange: handleChange,
    "data-dsx--local-time-input": tag
  });
});

// The enterKeyHint prop is present in React 17+; this type provides it inline
// for backwards compatibility with React 16
function range(start, end) {
  const length = end - start;
  return Array.from({
    length
  }, (x, i) => i + start);
}
function arrayIsEqual(arr, other) {
  if (arr.length !== other.length) {
    return false;
  }
  return arr.every((el, index) => el === other[index]);
}
function setIsEqual(a, b) {
  return a.size === b.size && [...a].every(x => b.has(x));
}

/**
 * The base set of props that are available on all inputs.
 * Also includes ClassNameProps, TagProps, and EnterKeyHintProps.
 * @param Key Additional props from HTMLInputElement to include.
 * @example StandardInputProps<'value' | 'onChange' | 'min' | 'max'>
 */

/** Parses an ISO YearMonth (YYYY-MM, with MM ranging from 1..12) */
function parseISOYearMonth(input) {
  if (!input) {
    return {
      valid: false
    };
  }
  const [yearStr, monthStr] = input.split('-');
  const year = yearStr ? parseInt(yearStr, 10) : undefined;
  const month = monthStr ? parseInt(monthStr, 10) : undefined;
  if (!year || !month) {
    return {
      valid: false,
      year,
      month
    };
  }
  return {
    valid: true,
    year,
    month
  };
}

/**
 * Returns whether a given month option should be selectable given a currently selected YearMonth value.
 */
function isMonthOptionEnabled(args) {
  const {
    option,
    value,
    min,
    max
  } = args;
  const valueYM = parseISOYearMonth(value);

  // If the year is not selected, all month options are valid to select
  const selectedYear = valueYM.year;
  if (!selectedYear) {
    return true;
  }

  // If the year is selected, check the validity of YYYY-MM for the selected year and the month option
  const valid = isWithinRange({
    value: `${selectedYear}-${formatMonth(option)}`,
    min,
    max
  });
  return valid;
}

/**
 * Returns whether a given year option should be selectable given a currently selected YearMonth value.
 */
function isYearOptionEnabled(args) {
  const {
    option,
    value,
    min,
    max
  } = args;
  const valueYM = parseISOYearMonth(value);

  // If the month is not selected, year options within the min and max range are valid to select
  const selectedMonth = valueYM.month;
  if (!selectedMonth) {
    const minYM = parseISOYearMonth(min || '');
    const maxYM = parseISOYearMonth(max || '');
    const meetsMin = !minYM.valid || option >= minYM.year;
    const meetsMax = !maxYM.valid || option <= maxYM.year;
    const valid = meetsMin && meetsMax;
    return valid;
  }

  // If the month is selected, check the validity of YYYY-MM for the year option and the selected month
  const valid = isWithinRange({
    value: `${option}-${formatMonth(selectedMonth)}`,
    min,
    max
  });
  return valid;
}
const YearMonthOps = {
  eq(a, b) {
    return a.year === b.year && a.month === b.month;
  },
  lt(a, b) {
    return a.year < b.year || a.year === b.year && a.month < b.month;
  },
  gt(a, b) {
    return a.year > b.year || a.year === b.year && a.month > b.month;
  },
  lte(a, b) {
    return YearMonthOps.lt(a, b) || YearMonthOps.eq(a, b);
  },
  gte(a, b) {
    return YearMonthOps.gt(a, b) || YearMonthOps.eq(a, b);
  },
  min(a, b) {
    if (a.valid && b.valid) {
      return YearMonthOps.lte(a, b) ? a : b;
    }
    if (a.valid) {
      return a;
    }
    if (b.valid) {
      return b;
    }
    return {
      valid: false
    };
  },
  max(a, b) {
    if (a.valid && b.valid) {
      return YearMonthOps.gte(a, b) ? a : b;
    }
    if (a.valid) {
      return a;
    }
    if (b.valid) {
      return b;
    }
    return {
      valid: false
    };
  }
};

/**
 * Returns whether a year/month string is within the specified range.
 * Min and max are both optional; if neither is present, any date is considered within the range.
 */
function isWithinRange(args) {
  const {
    value,
    min = '',
    max = ''
  } = args;
  const valueYM = parseISOYearMonth(value);
  if (!valueYM.valid) {
    return false;
  }
  const minYM = parseISOYearMonth(min);
  const maxYM = parseISOYearMonth(max);
  const meetsMin = !minYM.valid || YearMonthOps.gte(valueYM, minYM);
  const meetsMax = !maxYM.valid || YearMonthOps.lte(valueYM, maxYM);
  const valid = meetsMin && meetsMax;
  return valid;
}

/** Formats a month number from the range 1..12 in MM format */
function formatMonth(input) {
  return input.toFixed(0).padStart(2, '0');
}

/** Formats a year/month in ISO YearMonth (YYYY-MM) format */
function format(input) {
  if (!input.valid) {
    return '';
  }
  return `${input.year}-${formatMonth(input.month)}`;
}

/** Formats a month number from the range 1..12 according to a locale */
function formatLocaleMonth(input, locale) {
  const monthFormatter = new Intl.DateTimeFormat(locale, {
    month: 'long'
  });

  // The year and date is arbitrary; we only care about the month
  return monthFormatter.format(Date.UTC(2000, input - 1, 5));
}

/** Formats a year according to a locale */
function formatLocaleYear(input, locale) {
  const yearFormatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric'
  });

  // The month is arbitrary; we only care about the year
  return yearFormatter.format(Date.UTC(input, 5));
}

function YearMonthInputFallback(props) {
  const {
    max = '',
    min = '',
    value = '',
    onChange,
    readOnly
  } = props;
  const [yearValue = '', monthValue = ''] = value.split('-');
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const {
    locale
  } = useI18n();
  const thisYear = new Date().getUTCFullYear();
  const yearOptionEls = range(thisYear - 10, thisYear + 10).map(x => ({
    label: formatLocaleYear(x, locale),
    hidden: !isYearOptionEnabled({
      option: x,
      value,
      min,
      max
    }),
    value: x.toString()
  })).filter(x => !x.hidden).map(x => /*#__PURE__*/jsx("option", {
    value: x.value,
    children: x.label
  }, x.value));
  const monthOptionEls = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(x => ({
    label: formatLocaleMonth(x, locale),
    hidden: !isMonthOptionEnabled({
      option: x,
      value,
      min,
      max
    }),
    value: formatMonth(x)
  })).filter(x => !x.hidden).map(x => /*#__PURE__*/jsx("option", {
    value: x.value,
    children: x.label
  }, x.value));
  const yearRef = useRef(null);
  const monthRef = useRef(null);
  function handleChange(monthValue, yearValue) {
    const value = `${yearValue}-${monthValue}`;
    onChange(value);
  }
  const selectClassName = classNames(styles$4['input'], styles$4['sub-input'], styles$4['tabular-nums'], styles$4['width-auto'], styles$4['appearance-none']);

  // TODO(chriswil): intl for the order of inputs
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("select", {
      ...tags(props, 'year-month-input', 'fallback', 'month'),
      "aria-label": formatMessage('Month'),
      className: selectClassName,
      disabled: readOnly,
      ref: monthRef,
      value: monthValue,
      onChange: e => handleChange(e.target.value, yearValue),
      children: [/*#__PURE__*/jsx("option", {
        value: "",
        children: "---------"
      }), monthOptionEls]
    }), /*#__PURE__*/jsxs("select", {
      ...tags(props, 'year-month-input', 'fallback', 'year'),
      "aria-label": formatMessage('Year'),
      className: selectClassName,
      disabled: readOnly,
      ref: yearRef,
      value: yearValue,
      onChange: e => handleChange(monthValue, e.target.value),
      children: [/*#__PURE__*/jsx("option", {
        value: "",
        children: "----"
      }), yearOptionEls]
    })]
  });
}

/**
 * Allows the user to input a local datetime.
 */
function YearMonthInput(props) {
  const {
    className: callerClassName,
    disabled,
    loading,
    readOnly,
    tag,
    value,
    variant = 'default',
    onChange,
    ...inputProps
  } = props;
  const ref = useRef(null);
  const ua = use_UNSAFEUserAgentInfo();
  const shouldUseFallback = ua.formFactor !== 'mobile' && (ua.browser === 'firefox' || ua.browser === 'safari');
  function handleClick() {
    var _ref$current;
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
  }
  function handleMouseDown(e) {
    if (ref.current && e.target !== ref.current) {
      e.preventDefault();
    }
  }
  const containerClassName = classNames('dsx-component', styles$4['input-box'], styles$4['container'], styles$4[variant], readOnly && styles$4['read-only'], callerClassName);
  const inputClassName = classNames(styles$4['input'], styles$4['tabular-nums'], loading && styles$4['loading']);
  return /*#__PURE__*/jsxs("fieldset", {
    className: containerClassName,
    disabled: disabled,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    children: [shouldUseFallback ? /*#__PURE__*/jsx(YearMonthInputFallback, {
      ...props
    }) : /*#__PURE__*/jsx("input", {
      ...inputProps,
      ...tags(props, 'year-month-input'),
      className: inputClassName,
      readOnly: readOnly,
      type: "month",
      value: value,
      ref: ref,
      onChange: e => onChange(e.target.value)
    }), loading && /*#__PURE__*/jsx(UNSAFE_Icon, {
      icon: DsxLoadingSpinner,
      size: "size-500"
    })]
  });
}

/**
 * Allows the user to input a local date.
 */
function YearMonthRangeInput(props) {
  const {
    className: callerClassName,
    disabled,
    loading,
    readOnly,
    tag,
    value,
    variant = 'default',
    onChange,
    ...inputProps
  } = props;
  const {
    min = '',
    max = ''
  } = props;
  const startRef = useRef(null);
  const endRef = useRef(null);
  const [startValue, endValue] = value.split('/');
  const ua = use_UNSAFEUserAgentInfo();
  const shouldUseFallback = ua.formFactor !== 'mobile' && (ua.browser === 'firefox' || ua.browser === 'safari');
  function handleChange(startValue, endValue) {
    const value = `${startValue}/${endValue}`;
    onChange(value);
  }
  function handleStartClick() {
    var _startRef$current;
    (_startRef$current = startRef.current) === null || _startRef$current === void 0 || _startRef$current.focus();
  }
  function handleStartMouseDown(e) {
    if (startRef.current && e.target !== startRef.current) {
      e.preventDefault();
    }
  }
  function handleEndClick() {
    var _endRef$current;
    (_endRef$current = endRef.current) === null || _endRef$current === void 0 || _endRef$current.focus();
  }
  function handleEndMouseDown(e) {
    if (endRef.current && e.target !== endRef.current) {
      e.preventDefault();
    }
  }
  const containerClassName = classNames('dsx-component', styles$4['input-box'], styles$4['multi-container'], styles$4[variant], readOnly && styles$4['read-only'], callerClassName);
  const innerContainerClassName = classNames(styles$4['container']);
  const inputClassName = classNames(styles$4['input'], styles$4['tabular-nums'], loading && styles$4['loading']);
  const startYM = parseISOYearMonth(startValue);
  const endYM = parseISOYearMonth(endValue);
  const minYM = parseISOYearMonth(min);
  const maxYM = parseISOYearMonth(max);
  const startMin = format(minYM);
  const startMax = format(YearMonthOps.min(endYM, maxYM));
  const endMin = format(YearMonthOps.max(minYM, startYM));
  const endMax = format(maxYM);
  return /*#__PURE__*/jsxs("fieldset", {
    className: containerClassName,
    disabled: disabled,
    children: [/*#__PURE__*/jsxs("div", {
      className: innerContainerClassName,
      onClick: handleStartClick,
      onMouseDown: handleStartMouseDown,
      children: [shouldUseFallback ? /*#__PURE__*/jsx(YearMonthInputFallback, {
        max: startMax,
        min: startMin,
        readOnly: readOnly,
        tag: tag,
        value: startValue,
        onChange: value => handleChange(value, endValue)
      }) : /*#__PURE__*/jsx("input", {
        ...inputProps,
        ...tags(props, 'year-month-range-input', 'start'),
        className: inputClassName,
        max: startMax,
        min: startMin,
        readOnly: readOnly,
        ref: startRef,
        type: "month",
        value: startValue,
        onChange: e => handleChange(e.target.value, endValue)
      }), loading && /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: DsxLoadingSpinner,
        size: "size-500"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: innerContainerClassName,
      onClick: handleEndClick,
      onMouseDown: handleEndMouseDown,
      children: [shouldUseFallback ? /*#__PURE__*/jsx(YearMonthInputFallback, {
        max: endMax,
        min: endMin,
        readOnly: readOnly,
        tag: tag,
        value: endValue,
        onChange: value => handleChange(startValue, value)
      }) : /*#__PURE__*/jsx("input", {
        ...inputProps,
        ...tags(props, 'year-month-range-input', 'end'),
        className: inputClassName,
        max: endMax,
        min: endMin,
        readOnly: readOnly,
        ref: endRef,
        type: "month",
        value: endValue,
        onChange: e => handleChange(startValue, e.target.value)
      }), loading && /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: DsxLoadingSpinner,
        size: "size-500"
      })]
    })]
  });
}

// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
const extensionToMimeType = {
  '.7z': 'application/x-7z-compressed',
  '.aac': 'audio/aac',
  '.abw': 'application/x-abiword',
  '.arc': 'application/x-freearc',
  '.avi': 'video/x-msvideo',
  '.avif': 'image/avif',
  '.azw': 'application/vnd.amazon.ebook',
  '.bin': 'application/octet-stream',
  '.bmp': 'image/bmp',
  '.bz': 'application/x-bzip',
  '.bz2': 'application/x-bzip2',
  '.cda': 'application/x-cdf',
  '.csh': 'application/x-csh',
  '.css': 'text/css',
  '.csv': 'text/csv',
  '.doc': 'application/msword',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.eot': 'application/vnd.ms-fontobject',
  '.epub': 'application/epub+zip',
  '.gif': 'image/gif',
  '.gz': 'application/gzip',
  '.htm': 'text/html',
  '.html': 'text/html',
  '.ico': 'image/vnd.microsoft.icon',
  '.ics': 'text/calendar',
  '.jar': 'application/java-archive',
  '.jpeg': 'image/jpeg',
  '.jpg': 'image/jpeg',
  '.js': 'text/javascript',
  '.json': 'application/json',
  '.jsonld': 'application/ld+json',
  '.mid': 'audio/midi',
  '.midi': 'audio/midi',
  '.mjs': 'text/javascript',
  '.mp3': 'audio/mpeg',
  '.mp4': 'video/mp4',
  '.mpeg': 'video/mpeg',
  '.mpkg': 'application/vnd.apple.installer+xml',
  '.odp': 'application/vnd.oasis.opendocument.presentation',
  '.ods': 'application/vnd.oasis.opendocument.spreadsheet',
  '.odt': 'application/vnd.oasis.opendocument.text',
  '.oga': 'audio/ogg',
  '.ogv': 'video/ogg',
  '.ogx': 'application/ogg',
  '.opus': 'audio/opus',
  '.otf': 'font/otf',
  '.pdf': 'application/pdf',
  '.php': 'application/x-httpd-php',
  '.png': 'image/png',
  '.ppt': 'application/vnd.ms-powerpoint',
  '.pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  '.rar': 'application/vnd.rar',
  '.rtf': 'application/rtf',
  '.sh': 'application/x-sh',
  '.svg': 'image/svg+xml',
  '.tar': 'application/x-tar',
  '.tif': 'image/tiff',
  '.tiff': 'image/tiff',
  '.ts': 'video/mp2t',
  '.ttf': 'font/ttf',
  '.txt': 'text/plain',
  '.vsd': 'application/vnd.visio',
  '.wav': 'audio/wav',
  '.weba': 'audio/webm',
  '.webm': 'video/webm',
  '.webp': 'image/webp',
  '.woff': 'font/woff',
  '.woff2': 'font/woff2',
  '.xhtml': 'application/xhtml+xml',
  '.xls': 'application/vnd.ms-excel',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.xml': 'application/xml',
  '.xul': 'application/vnd.mozilla.xul+xml',
  '.zip': 'application/zip'
};

var css_248z$6 = ".FileInput-module_file-input-container__fxg5u {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: space-between;\n  gap: var(--size-300);\n}\n\n.FileInput-module_file-card__xGUG3 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--size-300);\n  border: 1px solid transparent;\n}\n\n.FileInput-module_file-card__xGUG3 > :first-child {\n  margin-left: var(--size-300);\n}\n\n.FileInput-module_file-card__xGUG3.FileInput-module_danger__tqIcx {\n  border-color: var(--color-danger);\n}\n\n.FileInput-module_file-card__xGUG3.FileInput-module_disabled__12Er- {\n  opacity: 0.4;\n}\n\n.FileInput-module_file-card-meta__l8lBm {\n  display: flex;\n  align-items: center;\n  gap: var(--size-300);\n  white-space: nowrap;\n}\n\n.FileInput-module_file-card-name__Y-UdE {\n  word-wrap: anywhere;\n}\n\n.FileInput-module_file-card-list__q44f- {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-300);\n  flex: 1 1 0%;\n}\n\n.FileInput-module_file-card-error-message__d9t9E {\n  margin-left: var(--size-300);\n}\n\n.FileInput-module_dropzone__PBwa0 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--size-300);\n  background-color: var(--color-gray-50);\n  border: 2px dashed var(--color-gray-200);\n  border-radius: var(--size-200);\n  padding: var(--size-400);\n  cursor: pointer;\n  transition: border-color 0.2s ease-in-out;\n}\n\n:disabled .FileInput-module_dropzone__PBwa0,\n.FileInput-module_dropzone-disabled__AELJe {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.FileInput-module_dropzone-active__6fa0C {\n  background-color: var(--color-primary-50);\n  border-color: var(--color-primary-500);\n}\n\n.FileInput-module_dropzone-reject__xhVOu {\n  background-color: var(--color-danger-50);\n  border-color: var(--color-danger-500);\n  cursor: not-allowed;\n}\n\n.FileInput-module_dropzone__PBwa0:hover {\n  border-color: var(--color-gray-300);\n}\n\n.FileInput-module_dropzone-description__Pxdz- {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--size-100);\n}\n\n.FileInput-module_upload-button__ismRy {\n  align-self: flex-start;\n}\n\n.FileInput-module_single-wrapper__O3exA .FileInput-module_upload-button__ismRy {\n  align-self: center;\n}\n\n.FileInput-module_browse-files__rAsL5 {\n  -webkit-text-decoration: underline;\n  text-decoration: underline;\n}\n\n.FileInput-module_dropzone__PBwa0:where(:hover, :focus) .FileInput-module_browse-files__rAsL5,\n.FileInput-module_dropzone-active__6fa0C .FileInput-module_browse-files__rAsL5 {\n  color: var(--color-primary-500);\n}\n\n.FileInput-module_single-wrapper__O3exA {\n  display: flex;\n  gap: var(--size-200);\n  align-items: center;\n}";
var styles$2 = {"file-input-container":"FileInput-module_file-input-container__fxg5u","file-card":"FileInput-module_file-card__xGUG3","danger":"FileInput-module_danger__tqIcx","disabled":"FileInput-module_disabled__12Er-","file-card-meta":"FileInput-module_file-card-meta__l8lBm","file-card-name":"FileInput-module_file-card-name__Y-UdE","file-card-list":"FileInput-module_file-card-list__q44f-","file-card-error-message":"FileInput-module_file-card-error-message__d9t9E","dropzone":"FileInput-module_dropzone__PBwa0","dropzone-disabled":"FileInput-module_dropzone-disabled__AELJe","dropzone-active":"FileInput-module_dropzone-active__6fa0C","dropzone-reject":"FileInput-module_dropzone-reject__xhVOu","dropzone-description":"FileInput-module_dropzone-description__Pxdz-","upload-button":"FileInput-module_upload-button__ismRy","single-wrapper":"FileInput-module_single-wrapper__O3exA","browse-files":"FileInput-module_browse-files__rAsL5"};
styleInject(css_248z$6);

function FileInputCard(props) {
  const {
    file,
    loadingState = 'initial',
    progress,
    error,
    disabled,
    onRemove
  } = props;
  const sizeStr = formatBytes(file.size);
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const {
    locale
  } = useI18n();
  let bodyEl = /*#__PURE__*/jsx(Fragment, {});
  if (loadingState === 'initial') {
    bodyEl = /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Text, {
        icon: DsxFileDocument,
        className: styles$2['file-card-name'],
        children: file.name
      }), /*#__PURE__*/jsxs("div", {
        className: styles$2['file-card-meta'],
        children: [/*#__PURE__*/jsx(Text, {
          variant: "body-compact",
          children: sizeStr
        }), /*#__PURE__*/jsx(Button, {
          icon: MdDelete,
          variant: "ui-control",
          onClick: onRemove,
          disabled: disabled,
          children: formatMessage('Remove')
        })]
      })]
    });
  }
  if (loadingState === 'loading') {
    const progressString = progress && new Intl.NumberFormat(locale, {
      style: 'percent'
    }).format(progress);
    bodyEl = /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Text, {
        icon: DsxLoadingSpinner,
        className: styles$2['file-card-name'],
        iconColor: "color-primary",
        children: file.name
      }), /*#__PURE__*/jsxs("div", {
        className: styles$2['file-card-meta'],
        children: [/*#__PURE__*/jsx(Text, {
          variant: "body-compact",
          children: progressString
        }), /*#__PURE__*/jsx(Button, {
          icon: MdClear,
          variant: "ui-control",
          onClick: onRemove,
          disabled: disabled,
          children: formatMessage('Cancel')
        })]
      })]
    });
  }
  if (loadingState === 'failure') {
    bodyEl = /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Text, {
        icon: MdError,
        className: styles$2['file-card-name'],
        iconColor: "color-danger",
        children: file.name
      }), /*#__PURE__*/jsxs("div", {
        className: styles$2['file-card-meta'],
        children: [/*#__PURE__*/jsx(Text, {
          variant: "body-compact",
          children: sizeStr
        }), /*#__PURE__*/jsx(Button, {
          icon: MdDelete,
          variant: "ui-control",
          onClick: onRemove,
          disabled: disabled,
          children: formatMessage('Remove')
        })]
      })]
    });
  }
  const errorEl = error && /*#__PURE__*/jsx(Text, {
    variant: "helper",
    color: "color-danger",
    className: styles$2['file-card-error-message'],
    children: error
  });
  const className = classNames(styles$2['file-card'], error && styles$2['danger'], disabled && styles$2['disabled']);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Card, {
      variant: "flat",
      bleed: "full",
      className: className,
      children: bodyEl
    }), errorEl]
  });
}
function formatBytes(bytes) {
  const units = ['B', 'KB', 'MB', 'GB'];
  let size = bytes;
  let unitIndex = 0;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size = size / 1024;
    unitIndex++;
  }
  return `${size.toFixed(2)} ${units[unitIndex]}`;
}

/**
 * A file input.
 */
function FileInput(props) {
  const {
    // variant = 'default',
    name,
    tag = name,
    accept,
    maxSize: maxInBytes,
    className: callerClassName,
    multiple,
    buttonVariant = 'default',
    onChange,
    value,
    disabled
  } = props;
  const containerClassName = classNames('dsx-component', callerClassName, styles$2['file-input-container']);
  const acceptObj = listToAccept(accept || []);
  const handleDrop = useCallback((acceptedFiles, fileRejections) => {
    const goodFiles = acceptedFiles.map(x => ({
      file: x
    }));
    const badFiles = fileRejections.map(x => ({
      file: x.file
    }));
    const files = [...goodFiles, ...badFiles];
    onChange({
      type: 'add',
      values: files
    });
  }, [onChange]);
  const handleRemove = useCallback(file => {
    onChange({
      type: 'remove',
      value: file
    });
  }, [onChange]);
  const {
    getInputProps,
    getRootProps,
    open,
    isDragAccept,
    isDragReject
  } = useDropzone({
    maxSize: maxInBytes,
    accept: acceptObj,
    multiple,
    noKeyboard: buttonVariant !== 'dropzone',
    onDrop: handleDrop,
    disabled
  });
  const {
    formatMessage,
    formatReactMessage
  } = useMessageFormatter(messages$1);
  let acceptListEl = /*#__PURE__*/jsx(Fragment, {});
  let maxEl = /*#__PURE__*/jsx(Fragment, {});
  let helpSectionEl = /*#__PURE__*/jsx(Fragment, {});
  let mainSectionEl = /*#__PURE__*/jsx(Fragment, {});
  const {
    locale
  } = useI18n();
  if (accept) {
    const list = new Intl.ListFormat(locale, {
      type: 'unit'
    }).format(accept.map(formatAccept));
    acceptListEl = /*#__PURE__*/jsx("li", {
      children: formatMessage('Accepted formats: {list}', {
        list
      })
    });
  }
  if (maxInBytes) {
    maxEl = /*#__PURE__*/jsx("li", {
      children: formatBytes(maxInBytes)
    });
  }
  const cardEls = value !== null && value !== void 0 && value.length ? (value || []).map(x => /*#__PURE__*/jsx(FileInputCard, {
    onRemove: () => handleRemove(x),
    disabled: disabled,
    ...x
  }, x.file.name)) : /*#__PURE__*/jsx(Text, {
    variant: "label-addendum",
    children: formatMessage('No file chosen')
  });
  const showHelpSection = maxInBytes || (accept === null || accept === void 0 ? void 0 : accept.length);
  if (showHelpSection) {
    helpSectionEl = /*#__PURE__*/jsxs("ul", {
      children: [maxEl, acceptListEl]
    });
  }
  if (buttonVariant === 'dropzone') {
    const dropzoneClassName = classNames(styles$2['dropzone'], disabled && styles$2['dropzone-disabled'], isDragAccept && styles$2['dropzone-active'], isDragReject && styles$2['dropzone-reject']);
    mainSectionEl = /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs("div", {
        ...getRootProps({
          className: dropzoneClassName
        }),
        children: [/*#__PURE__*/jsx("input", {
          ...getInputProps(),
          name: name,
          "data-dsx--file-input": tag
        }), /*#__PURE__*/jsxs("div", {
          className: styles$2['dropzone-description'],
          children: [/*#__PURE__*/jsx(StandaloneIcon, {
            icon: MdUpload,
            size: "size-600",
            title: formatMessage('Upload')
          }), /*#__PURE__*/jsx("div", {
            children: formatReactMessage('Drag and drop files here to upload or <q>browse files</q>.', {
              q: (v, i) => /*#__PURE__*/jsx("span", {
                className: styles$2['browse-files'],
                children: v
              }, i)
            })
          })]
        })]
      }), /*#__PURE__*/jsx("div", {
        className: styles$2['file-card-list'],
        children: cardEls
      })]
    });
  } else {
    const chooserAndListEl = /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Button, {
        variant: buttonVariant,
        onClick: open,
        className: styles$2['upload-button'],
        disabled: disabled,
        children: formatMessage('Choose file')
      }), /*#__PURE__*/jsx("div", {
        ...getRootProps(),
        children: /*#__PURE__*/jsx("input", {
          ...getInputProps(),
          name: name,
          "data-dsx--file-input": tag
        })
      }), /*#__PURE__*/jsx("div", {
        className: styles$2['file-card-list'],
        children: cardEls
      })]
    });
    if (multiple) {
      mainSectionEl = chooserAndListEl;
    } else {
      mainSectionEl = /*#__PURE__*/jsx("div", {
        className: styles$2['single-wrapper'],
        children: chooserAndListEl
      });
    }
  }
  return /*#__PURE__*/jsxs("div", {
    className: containerClassName,
    children: [helpSectionEl, mainSectionEl]
  });
}
function formatAccept(accept) {
  if (accept.startsWith('.')) {
    return accept;
  }
  if (accept.endsWith('/*')) {
    const [first] = accept.split('/');
    return first;
  }
  if (accept.includes('/')) {
    const [, rest] = accept.split('/');
    return rest;
  }
  return accept;
}
function listToAccept(accept) {
  const result = {};
  for (const value of accept) {
    let key = '';
    if (value.includes('/')) {
      key = value;
    }
    if (value.startsWith('.')) {
      key = extensionToMimeType[value] || 'application/octet-stream';
    }
    result[key] = [];
  }
  return result;
}

var css_248z$5 = ".Dropdown-module_content-label-wrapper__Z-mZA {\n  position: relative;\n  flex: 1 1 0%;\n}\n\n.Dropdown-module_content-label__30Phr {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.Dropdown-module_content-label__30Phr.Dropdown-module_placeholder__h8xMl {\n  color: var(--color-neutral-300);\n}\n\n.Dropdown-module_popover__9M5cp {\n  margin: 0;\n  padding: var(--size-300) 0;\n  border: none;\n  background-color: var(--color-gray-0);\n  box-shadow: var(--UNSAFE-dsx-popover-box-shadow);\n  border-radius: var(--border-radius-default);\n  max-height: 20rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.Dropdown-module_option__Y4Ccw,\n.Dropdown-module_no-data__zB6AM {\n  padding: var(--size-200) var(--size-400);\n  color: var(--color-gray-800);\n  font-weight: 500;\n  border: 2px solid transparent;\n  letter-spacing: var(--letter-spacing-16);\n}\n\n.Dropdown-module_option__Y4Ccw.Dropdown-module_disabled__zyvGb {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.Dropdown-module_option__Y4Ccw:not(.Dropdown-module_disabled__zyvGb) {\n  cursor: pointer;\n}\n\n.Dropdown-module_option__Y4Ccw:not(.Dropdown-module_disabled__zyvGb):hover {\n  background-color: var(--color-gray-50);\n  color: var(--color-primary-500);\n}\n\n.Dropdown-module_option__Y4Ccw:not(.Dropdown-module_disabled__zyvGb):active {\n  background-color: var(--color-gray-100);\n  color: var(--color-primary-600);\n}\n\n.Dropdown-module_option__Y4Ccw:not(.Dropdown-module_disabled__zyvGb).Dropdown-module_active__Lzs2k {\n  border-color: rgba(var(--color-primary-400-rgb), 0.4);\n}\n\n.Dropdown-module_option__Y4Ccw.Dropdown-module_selected__jAg-T {\n  background-color: var(--color-primary-50);\n  color: var(--color-primary-600);\n}\n\n.Dropdown-module_option-wrapper__hvY8N {\n  display: flex;\n  align-items: center;\n  gap: var(--size-100);\n}\n\n.Dropdown-module_multi-option-contents__KZlg6 {\n  display: flex;\n  align-items: center;\n  gap: var(--size-400);\n}\n\n.Dropdown-module_single-option-contents__kRXUs {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1 1 0%;\n}\n\n.Dropdown-module_no-data__zB6AM {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--size-300);\n  color: var(--color-gray-300);\n}\n\n.Dropdown-module_divider__ZKjY5 {\n  border-top: 1px solid var(--color-gray-100);\n  margin: var(--size-200) var(--size-400);\n}\n\n.Dropdown-module_indent-0__aK3ey {\n  padding-left: 0;\n}\n\n.Dropdown-module_indent-select-all__yqbMS {\n  padding-left: var(--size-400);\n}\n\n.Dropdown-module_indent-1__iVuyI {\n  padding-left: 2.5rem;\n}\n\n.Dropdown-module_indent-2__H9s3n {\n  padding-left: 5rem;\n}\n\n.Dropdown-module_indent-3__edw98 {\n  padding-left: 7.5rem;\n}\n\n.Dropdown-module_expand__bNLea {\n  margin: calc(-1 * var(--size-200)) 0;\n}\n\n.Dropdown-module_hidden__zLmk1 {\n  visibility: hidden;\n}\n\n.Dropdown-module_icon-stub__J5TZG {\n  width: var(--size-400);\n  height: var(--size-400);\n}";
var dropdownStyles = {"content-label-wrapper":"Dropdown-module_content-label-wrapper__Z-mZA","content-label":"Dropdown-module_content-label__30Phr","placeholder":"Dropdown-module_placeholder__h8xMl","popover":"Dropdown-module_popover__9M5cp","option":"Dropdown-module_option__Y4Ccw","no-data":"Dropdown-module_no-data__zB6AM","disabled":"Dropdown-module_disabled__zyvGb","active":"Dropdown-module_active__Lzs2k","selected":"Dropdown-module_selected__jAg-T","option-wrapper":"Dropdown-module_option-wrapper__hvY8N","multi-option-contents":"Dropdown-module_multi-option-contents__KZlg6","single-option-contents":"Dropdown-module_single-option-contents__kRXUs","divider":"Dropdown-module_divider__ZKjY5","indent-0":"Dropdown-module_indent-0__aK3ey","indent-select-all":"Dropdown-module_indent-select-all__yqbMS","indent-1":"Dropdown-module_indent-1__iVuyI","indent-2":"Dropdown-module_indent-2__H9s3n","indent-3":"Dropdown-module_indent-3__edw98","expand":"Dropdown-module_expand__bNLea","hidden":"Dropdown-module_hidden__zLmk1","icon-stub":"Dropdown-module_icon-stub__J5TZG"};
styleInject(css_248z$5);

function NoData(props) {
  const {
    loadingState,
    onSearch,
    search
  } = props;
  const {
    formatMessage,
    formatReactMessage
  } = useMessageFormatter(messages$1);
  switch (loadingState) {
    case 'loading':
      return /*#__PURE__*/jsx("div", {
        className: dropdownStyles['no-data'],
        children: /*#__PURE__*/jsx(Text, {
          children: search ? formatReactMessage('Searching for <q>{search}</q>', {
            search,
            q: chunk => /*#__PURE__*/jsx("q", {
              children: chunk
            }, chunk.join())
          }) : formatMessage('Searching...')
        })
      });
    case 'failure':
      return /*#__PURE__*/jsxs("div", {
        className: dropdownStyles['no-data'],
        children: [/*#__PURE__*/jsx(Text, {
          children: formatMessage('There was a problem completing your search')
        }), /*#__PURE__*/jsx(Button, {
          size: "small",
          onClick: () => onSearch === null || onSearch === void 0 ? void 0 : onSearch(search),
          children: formatMessage('Try again')
        })]
      });
    default:
      if (search) {
        return /*#__PURE__*/jsx("div", {
          className: dropdownStyles['no-data'],
          children: /*#__PURE__*/jsx(Text, {
            children: formatReactMessage('No results for <q>{search}</q>', {
              search,
              q: chunk => /*#__PURE__*/jsx("q", {
                children: chunk
              })
            })
          })
        });
      } else {
        return /*#__PURE__*/jsx("div", {
          className: dropdownStyles['no-data'],
          children: /*#__PURE__*/jsx(Text, {
            children: search ? formatReactMessage('No results for <q>{search}</q>', {
              search,
              q: chunk => /*#__PURE__*/jsx("q", {
                children: chunk
              })
            }) : formatMessage('No results')
          })
        });
      }
  }
}

function Dropdown(props) {
  const {
    activeId,
    children,
    className: callerClassName,
    closePopover,
    disabled,
    id,
    listId,
    loadingState,
    name,
    open,
    placeholder,
    search,
    searchRef,
    selectedLabel,
    tag,
    tagKey,
    value,
    variant = 'default',
    onBlur,
    onDropdownClick,
    onFocus,
    onSearch,
    onSearchInput,
    onSearchKeyDown
  } = props;
  const containerClassName = classNames('dsx-component', styles$4['input-box'], styles$4['container'], styles$4['arrow-input'], styles$4['cursor-text'], styles$4[variant], callerClassName);
  const searchInputClassName = classNames(styles$4['input']);
  const popoverClassName = classNames('dsx-component', dropdownStyles['popover']);
  const {
    portalTarget
  } = useA11y();
  const {
    floatingStyles,
    refs
  } = useFloating({
    open,
    placement: 'bottom-start',
    strategy: 'fixed',
    whileElementsMounted: autoUpdate,
    middleware: [offset(8), flip({
      crossAxis: false
    }), size({
      apply(_ref) {
        let {
          rects,
          elements
        } = _ref;
        Object.assign(elements.floating.style, {
          width: `${rects.reference.width}px`
        });
      }
    })]
  });
  function handleBlur() {
    if (open) {
      closePopover();
    }
    onBlur === null || onBlur === void 0 || onBlur();
  }
  function preventBlur(event) {
    event.preventDefault();
  }
  const contentLabel = selectedLabel ?? placeholder;
  const contentLabelClassName = classNames(dropdownStyles['content-label'], (open || selectedLabel == null) && dropdownStyles['placeholder']);
  const icon = loadingState === 'loading' ? DsxLoadingSpinner : MdKeyboardArrowDown;
  return /*#__PURE__*/jsxs("div", {
    className: styles$4['arrow-wrapper'],
    children: [/*#__PURE__*/jsxs("fieldset", {
      className: containerClassName,
      disabled: disabled,
      ref: refs.setReference,
      onClick: onDropdownClick,
      onMouseDown: preventBlur,
      [tagKey]: tag,
      children: [/*#__PURE__*/jsx("input", {
        name: name,
        type: "hidden",
        value: value
      }), /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: MdSearch,
        size: "size-500"
      }), /*#__PURE__*/jsxs("div", {
        className: dropdownStyles['content-label-wrapper'],
        children: [!search && /*#__PURE__*/jsx("div", {
          className: contentLabelClassName,
          children: contentLabel
        }), /*#__PURE__*/jsx("input", {
          "aria-activedescendant": activeId,
          "aria-autocomplete": "list",
          "aria-controls": listId,
          "aria-expanded": open,
          "aria-haspopup": "listbox",
          autoCorrect: "off",
          className: searchInputClassName,
          id: id,
          type: "text",
          ref: searchRef,
          role: "combobox",
          value: search,
          onBlur: handleBlur,
          onFocus: onFocus,
          onInput: onSearchInput,
          onKeyDown: onSearchKeyDown,
          [`${tagKey}--search`]: tag
        })]
      }), /*#__PURE__*/jsx("div", {
        "aria-hidden": true,
        className: styles$4['arrow'],
        children: /*#__PURE__*/jsx(UNSAFE_Icon, {
          icon: icon
        })
      })]
    }), portalTarget && /*#__PURE__*/createPortal( /*#__PURE__*/jsx(Dialog, {
      focusOnOpen: false,
      isOpen: open,
      className: popoverClassName,
      ref: refs.setFloating,
      style: floatingStyles,
      onMouseDown: preventBlur,
      [`${tagKey}--popover`]: tag,
      children: /*#__PURE__*/jsx("div", {
        children: children || /*#__PURE__*/jsx(NoData, {
          loadingState: loadingState,
          search: search,
          onSearch: onSearch
        })
      })
    }), portalTarget)]
  });
}

function MultiItem(props) {
  const {
    activeValue,
    option,
    id,
    value,
    onSelect
  } = props;
  const active = option.value === activeValue;
  const selected = value === null || value === void 0 ? void 0 : value.includes(option.value);
  const className = classNames(dropdownStyles['option'], dropdownStyles['multi-option-contents'], option.disabled && dropdownStyles['disabled'], active && dropdownStyles['active'], selected && dropdownStyles['selected']);
  const ref = useRef(null);
  useEffect(() => {
    if (active) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [active]);
  function handleClick() {
    if (!option.disabled) {
      onSelect(option.value);
    }
  }
  return /*#__PURE__*/jsxs("div", {
    "aria-selected": selected,
    className: className,
    id: id,
    ref: ref,
    role: "option",
    onClick: handleClick,
    children: [/*#__PURE__*/jsx(UNSAFE_Icon, {
      icon: selected ? MdCheckBox : MdCheckBoxOutlineBlank,
      size: "size-400"
    }), option.label]
  }, option.value);
}

const selectAllValue = Symbol('dsx-select-all');
function SelectAllItem(props) {
  const {
    activeValue,
    id,
    label,
    selected,
    onSelect
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const active = activeValue === selectAllValue;
  const className = classNames(dropdownStyles['option'], dropdownStyles['multi-option-contents'], active && dropdownStyles['active'], selected && dropdownStyles['selected']);
  const checkIcon = selected ? MdCheckBox : MdCheckBoxOutlineBlank;
  const ref = useRef(null);
  useEffect(() => {
    if (active) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [active]);
  return /*#__PURE__*/jsxs("div", {
    "aria-selected": selected,
    className: className,
    id: id,
    ref: ref,
    role: "option",
    onClick: onSelect,
    children: [/*#__PURE__*/jsx(UNSAFE_Icon, {
      icon: checkIcon,
      size: "size-400"
    }), label || formatMessage('Select all')]
  });
}

/* The number of options to move the selection by when pressing page up/down. */
const pageSize = 7;
/**
 * Translates keyboard events into semantic selection actions.
 */
function getActionFromKeyboardEvent(event, open) {
  const {
    key,
    altKey
  } = event;
  if (open) {
    switch (key) {
      case 'Escape':
        return 'close';
      case 'Enter':
        return 'select';
      case 'ArrowUp':
        return altKey ? 'select' : 'previous';
      case 'ArrowDown':
        return altKey ? 'select' : 'next';
      case 'ArrowLeft':
        return 'collapse';
      case 'ArrowRight':
        return 'expand';
      case 'PageUp':
        return 'pageup';
      case 'PageDown':
        return 'pagedown';
      default:
        return null;
    }
  } else {
    switch (key) {
      case 'Enter':
      case 'ArrowUp':
      case 'ArrowDown':
      case 'PageUp':
      case 'PageDown':
        return 'open';
      default:
        return null;
    }
  }
}

/**
 * Given a set of options, an active value, and a keyboard navigation action,
 * determine the value of the next selected option.
 *
 * When no value is active, the operation is performed relative to the index
 * preceding all options.
 *
 * Optionally this may take in a set of extra values which are considered to be
 * special option values that precede the normal select options.
 */
function navigateOptions(params) {
  const {
    action,
    options,
    extraValues,
    activeValue
  } = params;
  switch (action) {
    case 'previous':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: -1,
        wrap: true
      });
    case 'next':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: 1,
        wrap: true
      });
    case 'pageup':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: -pageSize,
        wrap: false
      });
    case 'pagedown':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: pageSize,
        wrap: false
      });
  }
}
function navigateOptionsByAmount(params) {
  const {
    options,
    extraValues = [],
    activeValue,
    dIndex,
    wrap
  } = params;
  const focusableOptions = options.filter(option => !option.disabled);
  const minIndex = -extraValues.length;
  const maxIndex = focusableOptions.length - 1;
  let index = extraValues.indexOf(activeValue);
  if (index != -1) {
    index = minIndex + index;
  } else {
    index = focusableOptions.findIndex(option => option.value === activeValue);
    if (index === -1) {
      index = minIndex - 1;
    }
  }
  index += dIndex;
  if (index < minIndex) {
    if (wrap) {
      index = maxIndex;
    } else {
      index = minIndex;
    }
  } else if (index > maxIndex) {
    if (wrap) {
      index = minIndex;
    } else {
      index = maxIndex;
    }
  }
  if (index < 0) {
    return extraValues[index - minIndex];
  } else {
    const option = focusableOptions[index];
    return option.value;
  }
}

/* The default implementation for the `searchFn` prop. */
function defaultSearchFn(options, search) {
  return options.filter(option => option.label.toUpperCase().includes(search.trim().toUpperCase()));
}
function defaultMultiSummary(selectedOptions, formatMessage) {
  if (selectedOptions.length === 1) {
    return selectedOptions[0].label;
  }
  if (selectedOptions.length > 1) {
    return formatMessage('{count} selected', {
      count: selectedOptions.length
    });
  }
}
function areAllSelected$1(selectedValues, options) {
  if (selectedValues.length === 0) {
    return false;
  }
  const selectedValueSet = new Set(selectedValues);
  const allValues = new Set(options.map(option => option.value));
  return setIsEqual(selectedValueSet, allValues);
}
function useSelectDropdown(props) {
  const {
    options,
    extraValues,
    searchFn = defaultSearchFn,
    searchMode = 'local',
    filterOptions = () => true,
    onOpen,
    onClose,
    onSearch,
    onOptionSelect,
    onActiveOptionCollapse,
    onActiveOptionExpand
  } = props;
  const uid = useUniqueId();
  const searchRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');

  /* The value of the active option (the option focused via keyboard) */
  const [activeValue, setActiveValue] = useState(null);
  const filteredOptions = useMemo(() => searchMode === 'local' ? searchFn(options, search) : options, [searchMode, options, search, searchFn]).filter(filterOptions);
  const activeOption = filteredOptions.find(option => option.value === activeValue);
  function openPopover() {
    setOpen(true);
    onOpen === null || onOpen === void 0 || onOpen();
  }
  function closePopover() {
    let clearSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    setOpen(false);
    setActiveValue(null);
    if (clearSearch) {
      setSearch('');
    }
    onClose === null || onClose === void 0 || onClose();
  }
  function handleDropdownClick(event) {
    if (open) {
      // Clicking on the filter text box should not collapse the popover.
      if (event.target !== searchRef.current) {
        closePopover(false);
      }
    } else {
      var _searchRef$current;
      openPopover();
      (_searchRef$current = searchRef.current) === null || _searchRef$current === void 0 || _searchRef$current.focus();
    }
  }
  function handleSearchInput(event) {
    const value = event.currentTarget.value;
    setSearch(value);
    onSearch === null || onSearch === void 0 || onSearch(value);
    if (!open) {
      openPopover();
    }
  }
  function handleSearchKeyDown(event) {
    const action = getActionFromKeyboardEvent(event, open);
    switch (action) {
      case 'open':
        openPopover();
        event.preventDefault();
        break;
      case 'close':
        closePopover();
        event.preventDefault();
        break;
      case 'select':
        if (activeValue != null) {
          onOptionSelect(activeValue);
        } else {
          closePopover();
        }
        event.preventDefault();
        break;
      case 'collapse':
        if (onActiveOptionCollapse) {
          onActiveOptionCollapse();
          event.preventDefault();
        }
        break;
      case 'expand':
        if (onActiveOptionExpand) {
          onActiveOptionExpand();
          event.preventDefault();
        }
        break;
      case 'previous':
      case 'next':
      case 'pageup':
      case 'pagedown':
        if (filteredOptions.length > 0) {
          setActiveValue(navigateOptions({
            action,
            options: filteredOptions,
            extraValues,
            activeValue
          }));
        }
        event.preventDefault();
        break;
    }
  }
  return {
    uid,
    searchRef,
    open,
    search,
    activeValue,
    setActiveValue,
    filteredOptions,
    activeOption,
    closePopover,
    onDropdownClick: handleDropdownClick,
    onSearchInput: handleSearchInput,
    onSearchKeyDown: handleSearchKeyDown
  };
}

/**
 * A dropdown input with filterable options which supports selection of multiple options.
 */
function MultiSearchSelectInput(props) {
  // Resources for developing custom combo boxes:
  // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
  // https://www.24a11y.com/2019/select-your-poison/
  const {
    className: callerClassName,
    disabled,
    id,
    includeSelectAll = false,
    loadingState,
    name,
    options,
    placeholder,
    renderSummary,
    selectAllLabel,
    tag,
    value,
    variant = 'default',
    onBlur,
    onChange,
    onFocus,
    onSearch
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const {
    activeOption,
    activeValue,
    closePopover,
    filteredOptions,
    open,
    search,
    searchRef,
    uid,
    onDropdownClick,
    onSearchInput,
    onSearchKeyDown
  } = useSelectDropdown({
    ...props,
    onOptionSelect: handleOptionSelect,
    extraValues: includeSelectAll ? [selectAllValue] : undefined
  });
  function handleOptionSelect(optionValue) {
    if (optionValue === selectAllValue) {
      handleSelectAll();
    } else {
      handleSelectOne(optionValue);
    }
  }
  function handleSelectAll() {
    const allValues = new Set(options.map(option => option.value));
    const selected = new Set(value);
    const allSelected = setIsEqual(allValues, selected);
    if (allSelected) {
      onChange([]);
    } else {
      onChange([...allValues]);
    }
  }
  function handleSelectOne(optionValue) {
    if (value == null) {
      onChange([optionValue]);
    } else if (value.includes(optionValue)) {
      onChange(value.filter(v => v !== optionValue));
    } else {
      onChange([...value, optionValue]);
    }
  }
  const selectedOptions = options.filter(option => value === null || value === void 0 ? void 0 : value.includes(option.value));
  const selectedLabel = (renderSummary === null || renderSummary === void 0 ? void 0 : renderSummary(value)) ?? defaultMultiSummary(selectedOptions, formatMessage);
  const activeLabelOrPlaceholder = activeOption != null ? (renderSummary === null || renderSummary === void 0 ? void 0 : renderSummary([activeValue])) ?? (activeOption === null || activeOption === void 0 ? void 0 : activeOption.label) : placeholder;
  const activeId = activeValue === selectAllValue ? `${uid}-option--select-all` : activeValue != null ? `${uid}-option-${activeValue}` : undefined;
  return /*#__PURE__*/jsx(Dropdown, {
    activeId: activeId,
    className: callerClassName,
    closePopover: closePopover,
    disabled: disabled,
    id: id,
    listId: `${uid}-list`,
    loadingState: loadingState,
    name: name,
    open: open,
    placeholder: activeLabelOrPlaceholder,
    search: search,
    searchRef: searchRef,
    selectedLabel: selectedLabel,
    tag: tag,
    tagKey: "data-dsx--multi-search-select-input",
    value: JSON.stringify(value),
    variant: variant,
    onBlur: onBlur,
    onDropdownClick: onDropdownClick,
    onFocus: onFocus,
    onSearch: onSearch,
    onSearchInput: onSearchInput,
    onSearchKeyDown: onSearchKeyDown,
    children: filteredOptions.length > 0 && /*#__PURE__*/jsxs(Fragment, {
      children: [includeSelectAll && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(SelectAllItem, {
          activeValue: activeValue,
          label: selectAllLabel,
          selected: areAllSelected$1(value, options),
          id: `${uid}-option--select-all`,
          onSelect: handleSelectAll
        }), /*#__PURE__*/jsx("div", {
          className: dropdownStyles['divider']
        })]
      }), filteredOptions.map(option => /*#__PURE__*/jsx(MultiItem, {
        activeValue: activeValue,
        option: option,
        id: `${uid}-option-${option.value}`,
        value: value,
        onSelect: handleOptionSelect
      }, option.value))]
    })
  });
}

function SingleItem(props) {
  const {
    activeValue,
    option,
    id,
    value,
    onSelect
  } = props;
  const active = option.value === activeValue;
  const selected = option.value === value;
  const className = classNames(dropdownStyles['option'], dropdownStyles['single-option-contents'], option.disabled && dropdownStyles['disabled'], active && dropdownStyles['active'], selected && dropdownStyles['selected']);
  const ref = useRef(null);
  useEffect(() => {
    if (active) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [active]);
  function handleClick() {
    if (!option.disabled) {
      onSelect(option.value);
    }
  }
  return /*#__PURE__*/jsx("div", {
    "aria-selected": selected,
    className: className,
    id: id,
    ref: ref,
    role: "option",
    onClick: handleClick,
    children: option.label
  }, option.value);
}

/**
 * A dropdown input with filterable options.
 */
function SearchSelectInput(props) {
  // Resources for developing custom combo boxes:
  // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
  // https://www.24a11y.com/2019/select-your-poison/
  const {
    className: callerClassName,
    disabled,
    id,
    loadingState,
    name,
    options,
    placeholder,
    renderSummary,
    tag,
    value,
    variant = 'default',
    onBlur,
    onChange,
    onFocus,
    onSearch
  } = props;
  const {
    activeOption,
    activeValue,
    closePopover,
    filteredOptions,
    open,
    search,
    searchRef,
    uid,
    onDropdownClick,
    onSearchInput,
    onSearchKeyDown
  } = useSelectDropdown({
    ...props,
    onOptionSelect: handleOptionSelect
  });
  function handleOptionSelect(value) {
    onChange(value);
    closePopover();
  }
  const selectedOption = options.find(option => option.value === value);
  const selectedLabel = (renderSummary === null || renderSummary === void 0 ? void 0 : renderSummary(value)) ?? (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label);
  const activeLabelOrPlaceholder = activeOption != null ? (renderSummary === null || renderSummary === void 0 ? void 0 : renderSummary(activeValue)) ?? activeOption.label : placeholder;
  const activeId = activeValue != null ? `${uid}-option-${activeValue}` : undefined;
  return /*#__PURE__*/jsx(Dropdown, {
    activeId: activeId,
    className: callerClassName,
    closePopover: closePopover,
    disabled: disabled,
    id: id,
    listId: `${uid}-list`,
    loadingState: loadingState,
    name: name,
    open: open,
    placeholder: activeLabelOrPlaceholder,
    search: search,
    searchRef: searchRef,
    selectedLabel: selectedLabel,
    tag: tag,
    tagKey: "data-dsx--search-select-input",
    value: value,
    variant: variant,
    onBlur: onBlur,
    onDropdownClick: onDropdownClick,
    onFocus: onFocus,
    onSearch: onSearch,
    onSearchInput: onSearchInput,
    onSearchKeyDown: onSearchKeyDown,
    children: filteredOptions.length > 0 && filteredOptions.map(option => /*#__PURE__*/jsx(SingleItem, {
      activeValue: activeValue,
      option: option,
      id: `${uid}-option-${option.value}`,
      value: value,
      onSelect: handleOptionSelect
    }, option.value))
  });
}

function TreeItem(props) {
  var _option$children;
  const {
    activeValue,
    option,
    id,
    value,
    onSelect,
    onExpandToggle,
    selectVariant
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const active = option.value === activeValue;
  const selected = value === null || value === void 0 ? void 0 : value.includes(option.value);
  const className = classNames(dropdownStyles['option'], dropdownStyles['option-wrapper'], dropdownStyles[`indent-${option.indentLevel}`], option.disabled && dropdownStyles['disabled'], active && dropdownStyles['active'], selected && dropdownStyles['selected']);
  const checkIcon = selectVariant === 'multi' ? option.indeterminate ? MdIndeterminateCheckBox : selected ? MdCheckBox : MdCheckBoxOutlineBlank : undefined;
  const showExpandButton = option.more || (((_option$children = option.children) === null || _option$children === void 0 ? void 0 : _option$children.length) || 0) > 0;
  const expandClassName = classNames(dropdownStyles['expand'], !showExpandButton && dropdownStyles['hidden']);
  const expandIcon = option.loadingState === 'loading' ? DsxLoadingSpinner : option.expanded ? MdKeyboardArrowDown : MdKeyboardArrowRight;
  const ref = useRef(null);
  useEffect(() => {
    if (active) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [active]);
  function handleExpandToggle(event) {
    event.preventDefault();
    event.stopPropagation();
    onExpandToggle(option.value);
  }
  function handleClick() {
    if (!option.disabled) {
      if (selectVariant === 'leaf' && !option.isLeaf) {
        onExpandToggle(option.value);
      } else {
        onSelect(option.value);
      }
    }
  }
  return /*#__PURE__*/jsxs("div", {
    "aria-selected": selected,
    className: className,
    id: id,
    ref: ref,
    role: "option",
    onClick: handleClick,
    children: [/*#__PURE__*/jsx(Button, {
      className: expandClassName,
      icon: expandIcon,
      iconOnly: true,
      size: "small",
      variant: "ui-control",
      onClick: handleExpandToggle,
      tag: option.value,
      children: formatMessage('Expand')
    }), /*#__PURE__*/jsxs("div", {
      className: selectVariant === 'multi' ? dropdownStyles['multi-option-contents'] : dropdownStyles['single-option-contents'],
      children: [checkIcon && /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: checkIcon,
        size: "size-400"
      }), option.label, selectVariant !== 'multi' && selected ? /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: MdDone,
        size: "size-400"
      }) : /*#__PURE__*/jsx("div", {
        className: dropdownStyles['icon-stub']
      })]
    })]
  }, option.value);
}

const maxIndent = 3;

/**
 * Perform a post-order depth-first traversal of the tree.
 */
function visit(options, f) {
  for (const option of options) {
    if (option.children) {
      visit(option.children, f);
    }
    f(option);
  }
}

/**
 * Perform a depth-first search of the tree.
 */
function find(options, value) {
  for (const option of options) {
    if (option.value === value) {
      return option;
    }
    if (option.children) {
      const maybe = find(option.children, value);
      if (maybe) {
        return maybe;
      }
    }
  }
  return null;
}

/**
 * Flattens the tree, maintaining information about indent level and each node's parent
 */
function flatten(options) {
  return function _flatten(options, currentIndent, parent, visible) {
    return options.flatMap(option => {
      const expanded = !!option.expanded;
      const flat = {
        ...option,
        indentLevel: currentIndent,
        parent,
        visible,
        original: option,
        isLeaf: !option.children
      };
      if (!option.children) {
        return [flat];
      }
      const nextIndent = Math.min(maxIndent, currentIndent + 1);
      return [flat, ..._flatten(option.children, nextIndent, flat, visible && expanded)];
    });
  }(options, 0, undefined, true);
}

/**
 * Returns an updated state for the tree given a modifying event.
 */
function reducer(state, action) {
  const next = structuredClone(state);
  const flatOptions = flatten(next.options);
  let nextValue = new Set(next.value);
  let performSort = false;
  switch (action.type) {
    case 'select-all':
      {
        const all = getAllValues(next.options);
        const allSelected = setIsEqual(all, nextValue);
        if (allSelected) {
          nextValue = new Set();
        } else {
          nextValue = all;
        }
      }
      break;
    case 'add':
      {
        const option = flatOptions.find(x => x.value === action.value);
        if (!option) {
          throw new Error(`This tree does not contain an option with value: ${action.value}`);
        }

        // the option in question and all of its children become checked
        (function addChildren(option) {
          nextValue.add(option.value);
          if (option.children != null) {
            for (const child of option.children) {
              addChildren(child);
            }
          }
        })(option.original);

        // set the ancestors of the option to checked as long as all of the children
        // of each ancestor are checked
        for (let parent = option.parent; parent != null; parent = parent.parent) {
          if (parent.children.every(child => nextValue.has(child.value))) {
            nextValue.add(parent.value);
          } else {
            break;
          }
        }
      }
      break;
    case 'remove':
      {
        const option = flatOptions.find(x => x.value === action.value);
        if (!option) {
          throw new Error(`This tree does not contain an option with value: ${action.value}`);
        }

        // the option in question and all of its children become unchecked
        (function removeChildren(option) {
          nextValue.delete(option.value);
          if (option.children != null) {
            for (const child of option.children) {
              removeChildren(child);
            }
          }
        })(option.original);

        // set the ancestors of the option to unchecked
        for (let parent = option.parent; parent != null; parent = parent.parent) {
          nextValue.delete(parent.value);
        }
      }
      break;
    case 'toggle':
      {
        const option = flatOptions.find(x => x.value === action.value);
        if (!option) {
          throw new Error(`This tree does not contain an option with value: ${action.value}`);
        }

        // the option in question changes its expanded state.
        option.original.expanded = !option.original.expanded;
      }
      break;
    case 'open':
      performSort = true;
      break;
    case 'add-single':
      nextValue = new Set([action.value]);
      break;
    case 'remove-single':
      nextValue = new Set();
      break;
  }

  // determine indeterminate states
  visit(next.options, option => {
    option.indeterminate = option.children != null && !nextValue.has(option.value) && option.children.some(child => child.indeterminate || nextValue.has(child.value));
  });
  if (performSort) {
    // all options are sorted by selection state
    const comparator = createSelectionStateComparator(nextValue);
    visit(next.options, option => {
      var _option$children;
      (_option$children = option.children) === null || _option$children === void 0 || _option$children.sort(comparator);
    });
    next.options.sort(comparator);
  }

  // give them sorted values always
  const nextAsArray = [...nextValue].sort((a, b) => a.localeCompare(b));

  // if it matches the original, return the original reference
  // so things like `useMemo` and `useEffect` can work properly
  next.value = arrayIsEqual(state.value, nextAsArray) ? state.value : nextAsArray;
  return next;
}
function areAllSelected(options, values) {
  const all = getAllValues(options);
  return setIsEqual(all, new Set(values));
}
function getAllValues(options) {
  const values = new Set();
  visit(options, x => values.add(x.value));
  return values;
}
function createSelectionStateComparator(values) {
  return (a, b) => {
    const aChecked = values.has(a.value);
    const bChecked = values.has(b.value);
    if (aChecked === bChecked && a.indeterminate === b.indeterminate) {
      return 0;
    }

    // Sort any checked options over any unchecked or indeterminate options
    if (aChecked) {
      return -1;
    }
    if (bChecked) {
      return 1;
    }

    // Sort any indeterminate options over any unchecked options
    if (a.indeterminate) {
      return -1;
    }
    if (b.indeterminate) {
      return 1;
    }
    return 0;
  };
}

/**
 * A dropdown input with filterable options.
 */
function TreeSelectInput(props) {
  // Resources for developing custom combo boxes:
  // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
  // https://www.24a11y.com/2019/select-your-poison/
  const {
    className: callerClassName,
    disabled,
    id,
    loadingState,
    name,
    options,
    placeholder,
    renderSummary,
    searchFn = defaultSearchFn,
    tag,
    value,
    variant = 'default',
    onBlur,
    onChange,
    onFocus,
    onOpen,
    onSearch,
    onToggle,
    changeVariant = 'multi'
  } = props;
  const flatOptions = flatten(options);
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const {
    activeOption,
    activeValue,
    closePopover,
    filteredOptions,
    open,
    search,
    searchRef,
    setActiveValue,
    uid,
    onDropdownClick,
    onSearchInput,
    onSearchKeyDown
  } = useSelectDropdown({
    ...props,
    extraValues: [selectAllValue],
    filterOptions: option => option.visible,
    options: flatOptions,
    searchFn: treeSearchFn,
    onOpen: handleOpen,
    onOptionSelect: handleOptionSelect,
    onActiveOptionCollapse: handleActiveOptionCollapse,
    onActiveOptionExpand: handleActiveOptionExpand
  });
  function treeSearchFn(options, search) {
    const matches = searchFn(options, search);
    const matchedValues = new Set(matches.map(option => option.value));

    // Include ancestors of matches in the result set
    for (const option of matches) {
      for (let parent = option.parent; parent != null; parent = parent.parent) {
        matchedValues.add(parent.value);
      }
    }

    // Include children of matches in the result set
    visit(matches, option => matchedValues.add(option.value));
    return options.filter(option => matchedValues.has(option.value));
  }
  function handleOpen() {
    const event = {
      type: 'open',
      value: ''
    };
    const next = reducer({
      options,
      value
    }, event);
    onOpen === null || onOpen === void 0 || onOpen({
      ...event,
      next
    });
  }
  function handleOptionSelect(value) {
    if (value === selectAllValue) {
      handleSelectAll();
    } else {
      handleSelectOne(value);
    }
  }
  function handleSelectAll() {
    const event = {
      type: 'select-all'
    };
    const next = reducer({
      options,
      value
    }, event);
    onChange(next.value, {
      ...event,
      next
    });
    if (changeVariant === 'single' || changeVariant === 'leaf') {
      closePopover();
    }
  }
  function handleSelectOne(optionValue) {
    const type = value != null && value.includes(optionValue) ? changeVariant === 'multi' ? 'remove' : 'remove-single' : changeVariant === 'multi' ? 'add' : 'add-single';
    const event = {
      type,
      value: optionValue
    };
    const next = reducer({
      options,
      value
    }, event);
    onChange(next.value, {
      ...event,
      next
    });
    if (changeVariant === 'single' || changeVariant === 'leaf') {
      closePopover();
    }
  }
  function handleActiveOptionCollapse() {
    var _activeOption$childre;
    if (activeOption == null) {
      return;
    }
    if ((_activeOption$childre = activeOption.children) !== null && _activeOption$childre !== void 0 && _activeOption$childre.length && activeOption.expanded) {
      const event = {
        type: 'toggle',
        value: activeOption.value
      };
      const next = reducer({
        options,
        value
      }, event);
      onToggle(activeOption.value, {
        ...event,
        next
      });
    } else if (activeOption.parent) {
      setActiveValue(activeOption.parent.value);
    }
  }
  function handleActiveOptionExpand() {
    var _activeOption$childre2;
    if (activeOption == null) {
      return;
    }
    if (!((_activeOption$childre2 = activeOption.children) !== null && _activeOption$childre2 !== void 0 && _activeOption$childre2.length)) {
      return;
    }
    if (!activeOption.expanded) {
      const event = {
        type: 'toggle',
        value: activeOption.value
      };
      const next = reducer({
        options,
        value
      }, event);
      onToggle(activeOption.value, {
        ...event,
        next
      });
    } else {
      setActiveValue(activeOption.children[0].value);
    }
  }
  function handleOptionExpandToggle(optionValue) {
    const event = {
      type: 'toggle',
      value: optionValue
    };
    const next = reducer({
      options,
      value
    }, event);
    onToggle(optionValue, {
      ...event,
      next
    });
  }
  const selectedOptions = flatOptions.filter(option => value === null || value === void 0 ? void 0 : value.includes(option.value));
  const selectedLabel = (renderSummary === null || renderSummary === void 0 ? void 0 : renderSummary(value)) ?? defaultMultiSummary(selectedOptions, formatMessage);
  const activeLabelOrPlaceholder = activeOption != null ? (renderSummary === null || renderSummary === void 0 ? void 0 : renderSummary([activeValue])) ?? (activeOption === null || activeOption === void 0 ? void 0 : activeOption.label) : placeholder;
  const activeId = activeValue === selectAllValue ? `${uid}-option--select-all` : activeValue != null ? `${uid}-option-${activeValue}` : undefined;
  return /*#__PURE__*/jsx(Dropdown, {
    activeId: activeId,
    className: callerClassName,
    closePopover: closePopover,
    disabled: disabled,
    id: id,
    listId: `${uid}-list`,
    loadingState: loadingState,
    name: name,
    open: open,
    placeholder: activeLabelOrPlaceholder,
    search: search,
    searchRef: searchRef,
    selectedLabel: selectedLabel,
    tag: tag,
    tagKey: "data-dsx--tree-select-input",
    value: JSON.stringify(value),
    variant: variant,
    onBlur: onBlur,
    onDropdownClick: onDropdownClick,
    onFocus: onFocus,
    onSearch: onSearch,
    onSearchInput: onSearchInput,
    onSearchKeyDown: onSearchKeyDown,
    children: filteredOptions.length > 0 && /*#__PURE__*/jsxs(Fragment, {
      children: [changeVariant === 'multi' && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(SelectAllItem, {
          activeValue: activeValue,
          selected: areAllSelected(options, value),
          id: `${uid}-option--select-all`,
          onSelect: handleSelectAll
        }), /*#__PURE__*/jsx("div", {
          className: dropdownStyles['divider']
        })]
      }), filteredOptions.map(option => /*#__PURE__*/jsx(TreeItem, {
        activeValue: activeValue,
        option: option,
        id: `${uid}-option-${option.value}`,
        value: value,
        onExpandToggle: handleOptionExpandToggle,
        onSelect: handleOptionSelect,
        selectVariant: changeVariant
      }, option.value))]
    })
  });
}
TreeSelectInput.find = find;
TreeSelectInput.visit = visit;

/**
 * A dropdown input.
 */
const SelectInput = /*#__PURE__*/forwardRef(function SelectInput(props, forwardedRef) {
  const {
    autoComplete = 'off',
    className: callerClassName,
    name,
    options,
    tag = name,
    variant = 'default',
    ...selectProps
  } = props;
  const containerClassName = classNames('dsx-component', styles$4['arrow-wrapper']);
  const selectClassName = classNames(styles$4['input-box'], styles$4['input'], styles$4['arrow-input'], styles$4[variant], callerClassName);
  return /*#__PURE__*/jsxs("span", {
    className: containerClassName,
    children: [/*#__PURE__*/jsx("select", {
      ...selectProps,
      autoComplete: autoComplete,
      className: selectClassName,
      name: name,
      ref: forwardedRef,
      "data-dsx--select-input": tag,
      children: options.map(optionProps => /*#__PURE__*/createElement("option", {
        ...optionProps,
        key: optionProps.value,
        "data-dsx--select-input--option": optionProps.value
      }, optionProps.label))
    }), /*#__PURE__*/jsx("div", {
      "aria-hidden": true,
      className: styles$4['arrow'],
      children: /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: MdKeyboardArrowDown
      })
    })]
  });
});

const ChatInput = /*#__PURE__*/forwardRef(
/**
 * A text area input.
 */
function ChatInput(props, forwardedRef) {
  const {
    variant = 'default',
    autoComplete = 'off',
    className: callerClassName,
    disabled,
    maxLines = 6,
    name,
    sendDisabled,
    tag = name,
    onChange: callerOnChange,
    onSend,
    readOnly,
    value: callerValue,
    ...inputProps
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const ref = useRef();
  const [value, onChange] = useControllableState(callerValue, '', callerOnChange);
  const canSend = !disabled && !sendDisabled && (value === null || value === void 0 ? void 0 : value.length);
  const handleResize = useCallback(() => {
    if (ref.current) {
      ref.current.style.height = 'inherit';
      if (ref.current.scrollHeight > ref.current.offsetHeight) {
        const borderHeight = ref.current.offsetHeight - ref.current.clientHeight;
        ref.current.style.height = `${ref.current.scrollHeight + borderHeight}px`;
      }
    }
  }, [ref]);
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);
  useLayoutEffect(handleResize, [handleResize, value]);
  function handleKeyDown(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSend();
    }
  }
  function handleChange(event) {
    onChange(event.currentTarget.value);
  }
  function handleClick() {
    var _ref$current;
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
  }
  function handleMouseDown(event) {
    if (event.target !== ref.current) {
      event.preventDefault();
    }
  }
  function handleSend() {
    if (canSend) {
      onSend(value);
      onChange('');
    }
  }
  const containerClassName = classNames('dsx-component', styles$4['chat-input'], styles$4['input-box'], styles$4['with-button'], styles$4['container'], styles$4['cursor-text'], styles$4[variant], readOnly && styles$4['read-only'], callerClassName);
  const inputClassName = classNames('dsx-component', styles$4['input']);
  return /*#__PURE__*/jsxs("fieldset", {
    className: containerClassName,
    disabled: disabled,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    children: [/*#__PURE__*/jsx("textarea", {
      ...inputProps,
      autoComplete: autoComplete,
      className: inputClassName,
      name: name,
      value: value,
      readOnly: readOnly,
      ref: combineRefs(forwardedRef, ref),
      rows: 1,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      "data-dsx--chat-input": tag,
      style: {
        ['--max-lines']: maxLines
      }
    }), /*#__PURE__*/jsx(Button, {
      className: styles$4['align-end'],
      disabled: !canSend,
      icon: MdSend,
      iconOnly: true,
      size: "small",
      variant: value ? 'primary' : 'ui-control',
      onClick: handleSend,
      children: formatMessage('Send message')
    })]
  });
});

var css_248z$4 = ".CurrencyInput-module_symbol__K1eyT {\n  color: var(--color-neutral-500);\n}";
var currencyStyles = {"symbol":"CurrencyInput-module_symbol__K1eyT"};
styleInject(css_248z$4);

const CurrencyInput = /*#__PURE__*/forwardRef(function CurrencyInput(props, forwardedRef) {
  const {
    align = 'start',
    autoComplete = 'off',
    className: callerClassName,
    currency,
    disabled,
    name,
    precision,
    readOnly,
    tag = name,
    value,
    variant = 'default',
    onBlur,
    onChange,
    UNSAFE_active,
    UNSAFE_focus,
    UNSAFE_hover,
    ...inputProps
  } = props;
  const ref = useRef(null);
  const {
    locale
  } = useI18n();
  const {
    symbol,
    symbolPosition
  } = getCurrencyFormat(currency, locale);
  const symbolEl = /*#__PURE__*/jsx("span", {
    className: currencyStyles['symbol'],
    children: symbol
  });
  function handleChangeRaw(ev) {
    var _ev$match;
    const matches = ((_ev$match = ev.match(/(-)?(\d+)?(\.(\d{1,2})?)?/g)) === null || _ev$match === void 0 ? void 0 : _ev$match[0]) || '';
    onChange(matches);
  }
  function handleChange(e) {
    if (!onChange) {
      return;
    }
    const ev = e.currentTarget.value;
    handleChangeRaw(ev);
  }
  function handleKeyDown(e) {
    if (['e', 'E', '+'].includes(e.key)) {
      e.preventDefault();
    }
  }
  function handlePaste(e) {
    const data = e.clipboardData.getData('Text');
    const exponentChar = /e/gi;
    if (exponentChar.test(data)) {
      e.preventDefault();
      onChange === null || onChange === void 0 || onChange(data.replace(exponentChar, ''));
    }
  }
  function formatDecimal(e) {
    if (!precision) {
      return;
    }
    const ev = parseFloat(e.target.value).toFixed(precision);
    handleChangeRaw(ev);
  }
  function handleBlur(e) {
    formatDecimal(e);
    onBlur === null || onBlur === void 0 || onBlur(e);
  }
  function handleClick() {
    var _ref$current;
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
  }
  function handleMouseDown(e) {
    if (e.target !== ref.current) {
      e.preventDefault();
    }
  }
  const containerClassName = classNames('dsx-component', styles$4['input-box'], styles$4['container'], styles$4['cursor-text'], styles$4[variant], readOnly && styles$4['read-only'], UNSAFE_hover && styles$4['hover'], UNSAFE_active && styles$4['active'], UNSAFE_focus && styles$4['focus'], callerClassName);
  const inputClassName = classNames(styles$4['input'], styles$4['tabular-nums'], styles$4[align]);

  // Q: Why use a text input instead of a number, here?
  // A: Safari on iOS lets the user type multiple decimal points, then
  // stops eventing out values after the number becomes invalid.
  // We do our best to emulate a sane native number input with
  // regexes, inputMode, and keydowns.

  // TODO(chriswil): implement min and max

  return /*#__PURE__*/jsxs("fieldset", {
    className: containerClassName,
    disabled: disabled,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    children: [symbolPosition === 'prefix' && symbolEl, /*#__PURE__*/jsx("input", {
      ...inputProps,
      autoComplete: autoComplete,
      className: inputClassName,
      inputMode: "decimal",
      name: name,
      readOnly: readOnly,
      ref: combineRefs(forwardedRef, ref),
      type: "text",
      value: value,
      onBlur: handleBlur,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      onPaste: handlePaste,
      onSubmit: formatDecimal,
      "data-dsx--currency-input": tag
    }), symbolPosition === 'suffix' && symbolEl]
  });
});

const NumberInput = /*#__PURE__*/forwardRef(function NumberInput(props, forwardedRef) {
  const {
    align = 'start',
    autoComplete = 'off',
    className: callerClassName,
    disabled,
    name,
    precision,
    readOnly,
    step,
    tag = name,
    unit,
    value,
    variant = 'default',
    onChange,
    UNSAFE_active,
    UNSAFE_focus,
    UNSAFE_hover,
    ...inputProps
  } = props;
  const ref = useRef(null);
  function handleChange(e) {
    if (!onChange) {
      return;
    }
    const ev = e.currentTarget.value;
    const val = getClosestValue(ev);
    onChange(val);
  }
  function getClosestValue(ev) {
    var _ev$match;
    let regex = /(-)?(\d+)?(\.(\d*)?)?/g;
    if (precision === 0) {
      regex = /(-)?(\d+)?/g;
    }
    if (precision && precision > 0) {
      regex = new RegExp(`(-)?(\\d+)?(\\.(\\d{0,${precision}})?)?`, 'g');
    }
    return ((_ev$match = ev.match(regex)) === null || _ev$match === void 0 ? void 0 : _ev$match[0]) || '';
  }
  function handleKeyDown(e) {
    if (['e', 'E', '+'].includes(e.key)) {
      e.preventDefault();
      return;
    }
    if (!step) {
      return;
    }
    const stepAsNumber = typeof step === 'string' ? parseFloat(step) : step;
    if (e.key === 'ArrowUp') {
      const ev = e.currentTarget.value;
      const val = getClosestValue(ev);
      const next = (val === '' ? 0 : parseFloat(val) + stepAsNumber).toString();
      onChange(next);
    }
    if (e.key === 'ArrowDown') {
      const ev = e.currentTarget.value;
      const val = getClosestValue(ev);
      const next = (val === '' ? 0 : parseFloat(val) - stepAsNumber).toString();
      onChange(next);
    }
  }
  function handlePaste(e) {
    const data = e.clipboardData.getData('Text');
    const exponentChar = /e/gi;
    if (exponentChar.test(data)) {
      e.preventDefault();
      onChange === null || onChange === void 0 || onChange(data.replace(exponentChar, ''));
    }
  }
  function handleClick() {
    var _ref$current;
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
  }
  function handleMouseDown(e) {
    if (e.target !== ref.current) {
      e.preventDefault();
    }
  }
  const containerClassName = classNames('dsx-component', styles$4['input-box'], styles$4['container'], styles$4['cursor-text'], styles$4[variant], readOnly && styles$4['read-only'], UNSAFE_hover && styles$4['hover'], UNSAFE_active && styles$4['active'], UNSAFE_focus && styles$4['focus'], callerClassName);
  const inputClassName = classNames(styles$4['input'], styles$4['tabular-nums'], styles$4[align]);

  // Q: Why use a text input instead of a number, here?
  // A: Safari on iOS lets the user type multiple decimal points, then
  // stops eventing out values after the number becomes invalid.
  // We do our best to emulate a sane native number input with
  // regexes, inputMode, and keydowns.

  // TODO(chriswil): implement min and max

  return /*#__PURE__*/jsxs("fieldset", {
    className: containerClassName,
    disabled: disabled,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    children: [/*#__PURE__*/jsx("input", {
      ...inputProps,
      autoComplete: autoComplete,
      className: inputClassName,
      inputMode: "decimal",
      name: name,
      readOnly: readOnly,
      ref: combineRefs(forwardedRef, ref),
      type: "text",
      value: value,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      onPaste: handlePaste,
      "data-dsx--number-input": tag
    }), unit != null && unit]
  });
});

/**
 * A password input.
 */
const PasswordInput = /*#__PURE__*/forwardRef(function PasswordInput(props, forwardedRef) {
  const {
    variant = 'default',
    autoComplete = 'off',
    name,
    tag = name,
    className: callerClassName,
    ...inputProps
  } = props;
  const className = classNames('dsx-component', styles$4['input-box'], styles$4['input'], styles$4[variant], callerClassName);
  return /*#__PURE__*/jsx("input", {
    ...inputProps,
    type: "password",
    autoComplete: autoComplete,
    className: className,
    ref: forwardedRef,
    "data-dsx--password-input": tag
  });
});

/**
 * A text input used for searching.
 */
const SearchTextInput = /*#__PURE__*/forwardRef(function SearchTextInput(props, forwardedRef) {
  const {
    variant = 'default',
    autoComplete = 'off',
    disabled,
    name,
    readOnly,
    tag = name,
    className: callerClassName,
    ...inputProps
  } = props;
  const ref = useRef(null);
  const containerClassName = classNames('dsx-component', styles$4['input-box'], styles$4['with-button'], styles$4['container'], styles$4['cursor-text'], styles$4[variant], readOnly && styles$4['read-only'], callerClassName);
  const inputClassName = classNames(styles$4['input']);
  function handleClick() {
    var _ref$current;
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
  }
  function handleMouseDown(e) {
    if (e.target !== ref.current) {
      e.preventDefault();
    }
  }
  return /*#__PURE__*/jsxs("fieldset", {
    className: containerClassName,
    disabled: disabled,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    children: [/*#__PURE__*/jsx(UNSAFE_Icon, {
      icon: MdSearch,
      size: "size-500"
    }), /*#__PURE__*/jsx("input", {
      ...inputProps,
      type: "text",
      autoComplete: autoComplete,
      className: inputClassName,
      readOnly: readOnly,
      ref: combineRefs(forwardedRef, ref),
      "data-dsx--search-text-input": tag
    })]
  });
});

const TextAreaInput = /*#__PURE__*/forwardRef(
/**
 * A text area input.
 */
function TextAreaInput(props, forwardedRef) {
  const {
    variant = 'default',
    autoComplete = 'off',
    className: callerClassName,
    name,
    tag = name,
    onChange,
    value,
    ...inputProps
  } = props;
  const ref = useRef();
  const handleResize = useCallback(() => {
    if (ref.current) {
      ref.current.style.height = 'inherit';
      if (ref.current.scrollHeight > ref.current.offsetHeight) {
        const borderHeight = ref.current.offsetHeight - ref.current.clientHeight;
        ref.current.style.height = `${ref.current.scrollHeight + borderHeight}px`;
      }
    }
  }, [ref]);
  function handleChange(event) {
    event.target.style.height = 'inherit';
    const borderHeight = event.target.offsetHeight - event.target.clientHeight;
    event.target.style.height = `${event.target.scrollHeight + borderHeight}px`;
    onChange && onChange(event);
  }
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);
  useLayoutEffect(handleResize, [handleResize, value]);
  const className = classNames('dsx-component', styles$4['input-box'], styles$4['input'], styles$4[variant], callerClassName);
  return /*#__PURE__*/jsx("textarea", {
    ...inputProps,
    autoComplete: autoComplete,
    className: className,
    name: name,
    value: value,
    ref: combineRefs(forwardedRef, ref),
    onChange: handleChange,
    "data-dsx--text-input": tag
  });
});

/**
 * A text input.
 */
const TextInput = /*#__PURE__*/forwardRef(function TextInput(props, forwardedRef) {
  const {
    variant = 'default',
    autoComplete = 'off',
    name,
    tag = name,
    className: callerClassName,
    UNSAFE_hover,
    UNSAFE_active,
    UNSAFE_focus,
    ...inputProps
  } = props;
  const className = classNames('dsx-component', styles$4['input-box'], styles$4['input'], styles$4[variant], UNSAFE_hover && styles$4['hover'], UNSAFE_active && styles$4['active'], UNSAFE_focus && styles$4['focus'], callerClassName);
  return /*#__PURE__*/jsx("input", {
    ...inputProps,
    type: "text",
    autoComplete: autoComplete,
    className: className,
    ref: forwardedRef,
    "data-dsx--text-input": tag
  });
});

var css_248z$3 = ".Form-module_field-container__nyPH- {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-100);\n}\n\n.Form-module_label-container__QsFqs {\n  display: flex;\n  gap: var(--size-200);\n}\n\n.Form-module_message-icon__vOe9A {\n  margin-top: var(--size-50);\n}";
var styles$1 = {"field-container":"Form-module_field-container__nyPH-","label-container":"Form-module_label-container__QsFqs","message-icon":"Form-module_message-icon__vOe9A"};
styleInject(css_248z$3);

function FieldMessages(props) {
  const {
    kind,
    value
  } = props;
  // TODO what do with rest

  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  let els = [];
  let iconEl = /*#__PURE__*/jsx(Fragment, {});
  const callerEls = toArr(value);
  if (callerEls.length === 0) {
    return /*#__PURE__*/jsx(Fragment, {});
  }
  if (kind === 'error') {
    els = callerEls.map((x, i) => /*#__PURE__*/jsx(Text, {
      variant: "helper",
      color: "color-danger",
      children: x
    }, i));
  } else if (kind === 'success') {
    els = callerEls.map((x, i) => /*#__PURE__*/jsx(Text, {
      variant: "helper",
      color: "color-success",
      children: x
    }, i));
  } else {
    els = callerEls.map((x, i) => /*#__PURE__*/jsx(Text, {
      variant: "helper",
      children: x
    }, i));
  }
  if (kind === 'error') {
    iconEl = /*#__PURE__*/jsx(StandaloneIcon, {
      className: styles$1['message-icon'],
      icon: MdError,
      color: "color-danger",
      title: formatMessage('Error')
    });
  } else if (kind === 'prominent-help') {
    iconEl = /*#__PURE__*/jsx(StandaloneIcon, {
      className: styles$1['message-icon'],
      icon: MdInfo,
      color: "color-primary",
      title: formatMessage('Help')
    });
  } else if (kind === 'warning') {
    iconEl = /*#__PURE__*/jsx(StandaloneIcon, {
      className: styles$1['message-icon'],
      icon: MdWarning,
      color: "color-warn",
      title: formatMessage('Warning')
    });
  } else if (kind === 'success') {
    iconEl = /*#__PURE__*/jsx(StandaloneIcon, {
      className: styles$1['message-icon'],
      icon: MdCheckCircle,
      color: "color-success",
      title: formatMessage('Success')
    });
  }
  return /*#__PURE__*/jsxs("div", {
    style: {
      display: 'flex',
      gap: 'var(--size-100)'
    },
    children: [iconEl, /*#__PURE__*/jsx("div", {
      className: styles$1['field-container'],
      children: els
    })]
  });
}
function toArr(value) {
  if (typeof value === 'undefined') {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [value];
}

/**
 * A required label for usage in a form.
 */
function Required(props) {
  const ref = useRef(null);
  const requiredStyle = useThemeVariable('UNSAFE-input-required-style', ref);
  const requiredEl = requiredStyle === 'star' ? /*#__PURE__*/jsx(LegacyDsxRequired, {
    ...props
  }) : /*#__PURE__*/jsx(DefaultDsxRequired, {
    ...props
  });
  return /*#__PURE__*/jsx("span", {
    className: "dsx-component",
    ref: ref,
    children: requiredEl
  });
}
function LegacyDsxRequired(props) {
  const {
    required,
    showIndicator,
    ...rest
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  if (!required) {
    return null;
  }
  return /*#__PURE__*/jsx(Text, {
    variant: "helper",
    color: "color-danger",
    element: "span",
    "aria-label": formatMessage('required'),
    ...rest,
    children: "*"
  });
}
function DefaultDsxRequired(props) {
  const {
    required,
    showIndicator,
    ...rest
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const showThisIndicator = showIndicator === 'required' && required || showIndicator === 'optional' && !required;
  if (!showThisIndicator) {
    return null;
  }
  const message = required ? formatMessage('required') : formatMessage('optional');
  return /*#__PURE__*/jsx(Text, {
    variant: "helper",
    element: "em",
    ...rest,
    children: message
  });
}

/** Internal, do not export from index */
function InputField(props) {
  const {
    label,
    required,
    children,
    error,
    help,
    prominentHelp,
    warning,
    success,
    tag,
    tagName,
    htmlFor,
    nesting = 'child',
    showIndicator = 'optional',
    className: callerClassName,
    labelClassName: callerLabelClassName
  } = props;
  const className = classNames('dsx-component', styles$1['field-container'], callerClassName);
  const labelClassName = classNames(styles$1['field-container'], callerLabelClassName);
  const getTag = tagFactory(tagName, tag);
  const messageEls = /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(FieldMessages, {
      kind: "error",
      value: error,
      ...getTag('error')
    }), /*#__PURE__*/jsx(FieldMessages, {
      kind: "success",
      value: success,
      ...getTag('success')
    }), /*#__PURE__*/jsx(FieldMessages, {
      kind: "warning",
      value: warning,
      ...getTag('warning')
    }), /*#__PURE__*/jsx(FieldMessages, {
      kind: "prominent-help",
      value: prominentHelp,
      ...getTag('prominent-help')
    }), /*#__PURE__*/jsx(FieldMessages, {
      kind: "help",
      value: help,
      ...getTag('help')
    })]
  });
  if (nesting === 'child') {
    return /*#__PURE__*/jsxs("div", {
      ...getTag('container'),
      className: className,
      children: [/*#__PURE__*/jsxs("label", {
        className: labelClassName,
        htmlFor: htmlFor,
        children: [/*#__PURE__*/jsxs(Text, {
          variant: "label",
          element: "div",
          className: styles$1['label-container'],
          children: [label, /*#__PURE__*/jsx(Required, {
            required: required,
            showIndicator: showIndicator,
            ...getTag('required')
          })]
        }), children]
      }), messageEls]
    });
  }
  return /*#__PURE__*/jsxs("div", {
    ...getTag('container'),
    className: className,
    children: [/*#__PURE__*/jsx("label", {
      className: labelClassName,
      htmlFor: htmlFor,
      children: /*#__PURE__*/jsxs(Text, {
        variant: "label",
        element: "div",
        className: styles$1['label-container'],
        children: [label, /*#__PURE__*/jsx(Required, {
          required: required,
          showIndicator: showIndicator,
          ...getTag('required')
        })]
      })
    }), children, messageEls]
  });
}
function tagFactory(component, value) {
  return part => ({
    [`data-dsx--${component}--${part}`]: value
  });
}

var css_248z$2 = ".CheckboxField-module_label__YAm1l {\n  border-radius: var(--border-radius-default);\n  box-shadow: 0 0 0 var(--size-50) transparent;\n  transition: 50ms ease box-shadow;\n}\n\n.CheckboxField-module_label__YAm1l:focus-within {\n  box-shadow: 0 0 0 var(--size-50) rgba(var(--color-blue-400-rgb), 0.4);\n}\n.CheckboxField-module_label__YAm1l:focus-within .CheckboxField-module_input__CuCsd {\n  box-shadow: none;\n}\n\n.CheckboxField-module_label__YAm1l:hover {\n  box-shadow: 0 0 0 var(--size-50) transparent;\n}\n\n.CheckboxField-module_input__CuCsd {\n  vertical-align: middle;\n}\n\n.CheckboxField-module_align-start__tq9AC {\n  align-items: flex-start;\n}";
var styles = {"label":"CheckboxField-module_label__YAm1l","input":"CheckboxField-module_input__CuCsd","align-start":"CheckboxField-module_align-start__tq9AC"};
styleInject(css_248z$2);

/**
 * A checkbox field for usage in a form.
 */
function CheckboxField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "checkbox-field",
    name: name,
    tag: tag,
    label: label,
    className: callerClassName,
    labelClassName: styles['align-start'],
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(CheckboxInput, {
      ...inputProps,
      tag: tag,
      className: styles['input']
    })
  });
}

var css_248z$1 = ".CheckboxGroupField-module_option-group-container__N72qX {\n  display: flex;\n  gap: var(--size-200);\n}\n\n.CheckboxGroupField-module_option-group__t3Vfs {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-200);\n  align-items: flex-start;\n  flex: 1 1 0%;\n}\n\n.CheckboxGroupField-module_label__9AqWM {\n  outline: none;\n  display: flex;\n  gap: var(--size-200);\n  align-items: flex-start;\n}\n\n.CheckboxGroupField-module_label-and-help__RSGFO {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-100);\n}\n\n.CheckboxGroupField-module_label-text__Slu9T {\n  line-height: 150%;\n}\n\n.CheckboxGroupField-module_input__QU2hb {\n  margin-top: 2px;\n}";
var fieldStyles$1 = {"option-group-container":"CheckboxGroupField-module_option-group-container__N72qX","option-group":"CheckboxGroupField-module_option-group__t3Vfs","label":"CheckboxGroupField-module_label__9AqWM","label-and-help":"CheckboxGroupField-module_label-and-help__RSGFO","label-text":"CheckboxGroupField-module_label-text__Slu9T","input":"CheckboxGroupField-module_input__QU2hb"};
styleInject(css_248z$1);

/**
 * A set of checkbox inputs for usage in a form.
 */
function CheckboxGroupField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    options,
    required,
    tag = name,
    showIndicator = 'optional',
    value,
    className: callerClassName,
    layout = 'default',
    onChange,
    ...inputProps
  } = props;
  const middleOptionsIdx = Math.ceil(options.length / 2);
  const optionGroups = layout === 'default' ? [options] : [options.slice(0, middleOptionsIdx), options.slice(middleOptionsIdx)];
  const handleChange = useCallback(e => {
    onChange(e, toggleMembership(value, e.target.value));
  }, [onChange, value]);
  return /*#__PURE__*/jsx(InputField, {
    tagName: "checkbox-group-field",
    nesting: "sibling",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx("div", {
      className: fieldStyles$1['option-group-container'],
      children: optionGroups.map(g => /*#__PURE__*/jsx("div", {
        className: fieldStyles$1['option-group'],
        children: g.map(o => /*#__PURE__*/jsxs("label", {
          className: fieldStyles$1['label'],
          children: [/*#__PURE__*/jsx(CheckboxInput, {
            ...inputProps,
            value: o.value,
            onChange: handleChange,
            checked: Array.isArray(value) && value.includes(o.value),
            className: fieldStyles$1['input']
          }), /*#__PURE__*/jsxs("div", {
            className: fieldStyles$1['label-and-help'],
            children: [/*#__PURE__*/jsx(Text, {
              variant: "body",
              className: fieldStyles$1['label-text'],
              children: o.label
            }), o.help && /*#__PURE__*/jsx(Text, {
              variant: "helper",
              children: o.help
            })]
          })]
        }, o.value))
      }, g.map(o => o.value).join()))
    })
  });
}
function toggleMembership(arr, val) {
  const idx = arr.indexOf(val);
  if (idx === -1) {
    return arr.concat(val);
  }
  return arr.filter(x => x !== val);
}

var css_248z = ".RadioGroupField-module_radio-container__QvZoL {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-200);\n  align-items: flex-start;\n}\n\n.RadioGroupField-module_label__oHaCa {\n  outline: none;\n  display: flex;\n  gap: var(--size-200);\n  align-items: flex-start;\n}\n\n.RadioGroupField-module_label-and-help__Lnohn {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-100);\n}\n\n.RadioGroupField-module_label-text__Ko2o6 {\n  line-height: 150%;\n}\n\n.RadioGroupField-module_input__GS9Je {\n  margin-top: 2px;\n}";
var fieldStyles = {"radio-container":"RadioGroupField-module_radio-container__QvZoL","label":"RadioGroupField-module_label__oHaCa","label-and-help":"RadioGroupField-module_label-and-help__Lnohn","label-text":"RadioGroupField-module_label-text__Ko2o6","input":"RadioGroupField-module_input__GS9Je"};
styleInject(css_248z);

/**
 * A set of radio inputs for usage in a form.
 */
function RadioGroupField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    options,
    required,
    value,
    tag = name,
    showIndicator = 'optional',
    onChange,
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "radio-group-field",
    nesting: "sibling",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx("div", {
      className: fieldStyles['radio-container'],
      children: options.map(o => /*#__PURE__*/jsxs("label", {
        className: fieldStyles['label'],
        children: [/*#__PURE__*/jsx(RadioInput, {
          ...inputProps,
          onChange: onChange,
          value: o.value,
          checked: value === o.value,
          className: fieldStyles['input']
        }), /*#__PURE__*/jsxs("div", {
          className: fieldStyles['label-and-help'],
          children: [/*#__PURE__*/jsx(Text, {
            variant: "body",
            className: fieldStyles['label-text'],
            children: o.label
          }), o.help && /*#__PURE__*/jsx(Text, {
            variant: "helper",
            children: o.help
          })]
        })]
      }, o.value))
    })
  });
}

function ToggleField(props) {
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const {
    checked,
    className: callerClassName,
    label,
    labelChecked = formatMessage('On'),
    labelUnchecked = formatMessage('Off'),
    tag,
    layout = 'standalone',
    help
  } = props;
  const containerClassName = classNames('dsx-component', styles$5['toggle'], styles$5[layout], callerClassName);
  const stateLabel = checked ? labelChecked : labelUnchecked;
  const labelHelpEl = /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx(Text, {
      element: "span",
      className: styles$5['hyphens'],
      children: label
    }), help && /*#__PURE__*/jsx(Text, {
      variant: "helper",
      children: help
    })]
  });
  if (layout === 'standalone') {
    return /*#__PURE__*/jsxs("label", {
      "data-dsx--toggle": tag,
      className: containerClassName,
      children: [/*#__PURE__*/jsx(ToggleInput, {
        ...props
      }), labelHelpEl]
    });
  }
  return /*#__PURE__*/jsxs("label", {
    "data-dsx--toggle": tag,
    className: containerClassName,
    children: [labelHelpEl, /*#__PURE__*/jsxs("div", {
      className: styles$5['centered-container'],
      children: [/*#__PURE__*/jsx(Text, {
        children: stateLabel
      }), /*#__PURE__*/jsx(ToggleInput, {
        ...props
      })]
    })]
  });
}

/**
 * A calendar for selecting dates.
 */
function DatePickerField(props) {
  const {
    className: callerClassName,
    error,
    help,
    label,
    name,
    prominentHelp,
    required,
    success,
    tag = name,
    showIndicator = 'optional',
    warning,
    ...inputProps
  } = props;

  // TODO(chriswil): Is it ok that the label is not associated to anything?

  return /*#__PURE__*/jsx(InputField, {
    tagName: "date-picker-field",
    name: name,
    tag: tag,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(DatePickerInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A LocalDate field for usage in forms.
 * @example 2021-01-01
 */
function LocalDateField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;

  // TODO(chriswil): Include min, max, step(?) as implicit rules

  return /*#__PURE__*/jsx(InputField, {
    tagName: "local-date-field",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(LocalDateInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A LocalDateRange field for usage in forms.
 * @example 2021-01-01/2021-02-01
 */
function LocalDateRangeField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "local-date-range-field",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(LocalDateRangeInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A LocalDateTime field for usage in forms.
 * @example 2021-01-01T14:30
 */
function LocalDateTimeField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;

  // TODO(chriswil): Include min, max, step(?) as implicit rules

  return /*#__PURE__*/jsx(InputField, {
    tagName: "local-date-time-field",
    name: name,
    tag: tag,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(LocalDateTimeInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A LocalTime field for usage in forms.
 * @example 14:30
 */
function LocalTimeField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;

  // TODO(chriswil): Include min, max, step(?) as implicit rules

  return /*#__PURE__*/jsx(InputField, {
    tagName: "number-field",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(LocalTimeInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A YearMonth field for usage in forms.
 * @example 2021-01
 */
function YearMonthField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;

  // TODO(chriswil): Include min, max, step(?) as implicit rules

  return /*#__PURE__*/jsx(InputField, {
    tagName: "year-month-field",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(YearMonthInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A YearMonthRange field for usage in forms.
 * @example 2021-01/2021-02
 */
function YearMonthRangeField(props) {
  const {
    name,
    label,
    secondaryLabel,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;

  // TODO(chriswil): Include min, max, step(?) as implicit rules

  return /*#__PURE__*/jsx(InputField, {
    tagName: "year-month-range-field",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(YearMonthRangeInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A File filed for usage in forms.
 */
function FileField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "file-field",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    nesting: "sibling",
    htmlFor: name,
    children: /*#__PURE__*/jsx(FileInput, {
      ...inputProps,
      tag: tag,
      name: name
    })
  });
}

/**
 * A dropdown field for usage in a form.
 */
function MultiSearchSelectField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "multi-search-select-field",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(MultiSearchSelectInput, {
      ...inputProps,
      tag: tag
    })
  });
}

/**
 * A dropdown field for usage in a form.
 */
function SearchSelectField(props) {
  const {
    name,
    label,
    required,
    help,
    prominentHelp,
    success,
    warning,
    error,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "search-select-field",
    tag: tag,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    name: name,
    children: /*#__PURE__*/jsx(SearchSelectInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A checkbox field for usage in a form.
 */
function TreeSelectField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "tree-select-field",
    name: name,
    tag: tag,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(TreeSelectInput, {
      ...inputProps,
      tag: tag
    })
  });
}

/**
 * A dropdown field for usage in a form.
 */
function SelectField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "select-field",
    name: name,
    tag: tag,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(SelectInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A currency field for usage in forms.
 */
function CurrencyField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    tag = name,
    showIndicator = 'optional',
    precision,
    required,
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "currency-field",
    name: name,
    tag: tag,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(CurrencyInput, {
      tag: tag,
      precision: precision,
      ...inputProps
    })
  });
}

/**
 * A number field for usage in forms.
 */
function NumberField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;

  // TODO: The input deals in strings, but this field should event out numbers,
  // and intelligently handle empty string null, etc.
  // See also this browser warning:
  //
  // react-dom.development.js:67
  // Warning: `value` prop on `input` should not be null.
  // Consider using an empty string to clear the component or `undefined` for uncontrolled components.

  return /*#__PURE__*/jsx(InputField, {
    tagName: "number-field",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(NumberInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A single-line password field for usage in a form.
 */
function PasswordField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "password-field",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(PasswordInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A multi-line text field for usage in a form.
 */
function TextAreaField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "textarea-field",
    name: name,
    tag: tag,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(TextAreaInput, {
      tag: tag,
      ...inputProps
    })
  });
}

/**
 * A single-line text field for usage in a form.
 */
const TextField = /*#__PURE__*/forwardRef(function TextField(props, ref) {
  const {
    name,
    label,
    required,
    help,
    prominentHelp,
    success,
    warning,
    error,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;
  return /*#__PURE__*/jsx(InputField, {
    tagName: "text-field",
    name: name,
    tag: tag,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(TextInput, {
      ref: ref,
      tag: tag,
      ...inputProps
    })
  });
});

export { ChatInput, CheckboxField, CheckboxGroupField, CheckboxInput, CurrencyField, CurrencyInput, DatePickerField, DatePickerInput, FileField, FileInput, LocalDateField, LocalDateInput, LocalDateRangeField, LocalDateRangeInput, LocalDateTimeField, LocalDateTimeInput, LocalTimeField, LocalTimeInput, MultiSearchSelectField, MultiSearchSelectInput, NumberField, NumberInput, PasswordField, PasswordInput, RadioGroupField, RadioInput, SearchBar, SearchSelectField, SearchSelectInput, SearchTextInput, SelectField, SelectInput, TextAreaField, TextAreaInput, TextField, TextInput, ToggleField, ToggleInput, TreeSelectField, TreeSelectInput, YearMonthField, YearMonthInput, YearMonthRangeField, YearMonthRangeInput };
